// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Tooltip } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useAuth } from '../../../context/AuthContext';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';

// const ProductDetails = ({ initialData, onNext, clientData, connectionString, mode, isFinalLocked }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const state = clientData?.details?.['State'];
//     const compState = selectedCompany?.State;
//     console.log(state, compState);
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [productMap, setProductMap] = useState(new Map());
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [unitMap, setUnitMap] = useState(new Map());
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});
//     const [totals, setTotals] = useState({ basic: '0.00', discount: '0.00', cgst: '0.00', sgst: '0.00', igst: '0.00', roundOff: '0.00', total: '0.00' });
//     const [originalEditQty, setOriginalEditQty] = useState(null);
//     const [isEditingMode, setIsEditingMode] = useState(false);

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const rowsRef = useRef([]);
//     useEffect(() => {
//         rowsRef.current = rows;
//     }, [rows]);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const [unitsRes, cRes, sRes] = await Promise.all([
//                     axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } }),
//                     axios.get(`${connectionString}/api/colormaster`),
//                     axios.get(`${connectionString}/api/sizemaster`),
//                 ]);
//                 const unitsData = unitsRes?.data || [];
//                 const units = unitsData.map(u => u.unit);
//                 const unitIdMap = new Map(unitsData.map(u => [u.unit, u.UnitId]));
//                 setUnitOptions(units);
//                 setUnitMap(unitIdMap);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };
//         fetchData();
//         loadAllProducts();
//     }, []);

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data || []);
//             setProductMap(new Map(res.data.map(p => [p.Id, p])));
//         } catch (e) {
//             console.error('Error loading products:', e);
//         }
//     };

//     useEffect(() => {
//         if (!initialData?.tableData || !Array.isArray(initialData.tableData)) {
//             if (rowsRef.current.length > 0) {
//                 setRows(rowsRef.current);
//             }
//             return;
//         }
//         console.log("init data:", initialData);

//         const isEditMode = initialData.tableData.some(r => r.challanDtsID || r.challanID);
//         console.log("Detected Mode:", isEditMode ? "Edit" : "Ref");

//         const initialRows = initialData.tableData.map((r, index) => {
//             let qty, dispatchQty;

//             if (mode === 'edit') {
//                 // For edit mode: use raw values from database directly
//                 qty = Number(r.qty) || 1;
//                 dispatchQty = Number(r.dispQty) || Number(r.dispatchQty) || 1;
//                 console.log(r.dispQty);
//             } else {
//                 // For ref/add mode: Backend already calculates remaining qty
//                 // qty = remaining quantity (originalQty - challanDispatchedQty)
//                 // dispatchQty = remaining quantity (same as qty, what can be dispatched)
//                 // Use the values directly from backend - they are already the remaining quantities
//                 qty = Number(r.qty) || 0;
//                 dispatchQty = Number(r.dispatchQty) || Number(r.qty) || 0;

//                 // If qty is 0, it means fully dispatched - this shouldn't happen as backend filters it out
//                 // But as a safety net, set minimum to 1 only if qty > 0
//                 if (qty === 0) {
//                     console.warn(`Product ${r.productCode} has 0 qty - should have been filtered by backend`);
//                 }
//             }

//             const rate = parseFloat(r.rate) || 0;
//             const disc = parseFloat(r.disc) || 0;
//             const amount = parseFloat((dispatchQty * rate * (1 - disc / 100)).toFixed(2));

//             const gst = parseFloat(r.GST) || 0;
//             const cgst = parseFloat(r.CGST) || 0;
//             const sgst = parseFloat(r.SGST) || 0;
//             const igst = parseFloat(r.IGST) || 0;
//             const taxPercent = gst || (cgst + sgst) || igst || 0;

//             let unitName = '';
//             if (r.unit && r.unit.toString().trim()) {
//                 unitName = r.unit.toString().trim();
//             } else if (r.Unit && r.Unit.toString().trim()) {
//                 unitName = r.Unit.toString().trim();
//             } else if (r.UnitId) {
//                 unitName = Array.from(unitMap.entries()).find(([_, id]) => String(id) === String(r.UnitId))?.[0] || '';
//             }

//             const POID = r.POID ?? r.POId ?? r.POID ?? null;
//             const PODtsID = r.PODtsID ?? r.PODtsId ?? r.PODtsID ?? null;

//             const row = {
//                 ...r,
//                 productId: r.productId || r.Id || r.id,
//                 UnitId: r.UnitId || null,
//                 unit: unitName,
//                 qty: qty,
//                 dispatchQty: dispatchQty,
//                 rate,
//                 disc,
//                 tax: taxPercent,
//                 amount,
//                 taxAmount: parseFloat((amount * taxPercent / 100).toFixed(2)),
//                 taxableAmount: amount,
//                 minLevel: r.minLevel === null ? null : parseFloat(r.minLevel) || Infinity,
//                 srNo: initialData.tableData.length - index,
//                 id: initialData.tableData.length - index,
//                 GST: `${taxPercent}%`,
//                 CGST: cgst.toString(),
//                 SGST: sgst.toString(),
//                 IGST: igst.toString(),
//                 POID,
//                 PODtsID,
//                 // Store original values for reference
//                 originalQty: Number(r.originalQty) || qty,
//                 challanDispatchedQty: Number(r.challanDispatchedQty) || 0,
//             };

//             console.log(`Loading row (Mode: ${isEditMode ? 'Edit' : 'Ref'}): qty=${qty}, dispatchQty=${dispatchQty}, POID=${POID}, PODtsID=${PODtsID}, originalQty=${r.originalQty}, challanDispatchedQty=${r.challanDispatchedQty}`);
//             return row;
//         });

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//     }, [initialData?.tableData, unitMap]);

//     useEffect(() => {
//         setTotals(calculateTotals());
//     }, [rows, state, compState]);

//     const calcAmount = ({ dispatchQty, rate, disc }) => parseFloat((dispatchQty * rate * (1 - disc / 100)).toFixed(2));
//     const calcTaxAmount = ({ dispatchQty, rate, disc, tax }) => parseFloat((dispatchQty * rate * (1 - disc / 100) * (tax / 100)).toFixed(2));

//     const calculateTotals = () => {
//         const basic = rows.reduce((sum, r) => sum + calcAmount(r), 0);
//         const discount = rows.reduce((sum, r) => sum + (r.dispatchQty * r.rate * (r.disc / 100)), 0);
//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const cgstTotal = isSameState ? rows.reduce((sum, r) => sum + (parseFloat(r.CGST) * calcAmount(r) / 100), 0) : 0;
//         const sgstTotal = isSameState ? rows.reduce((sum, r) => sum + (parseFloat(r.SGST) * calcAmount(r) / 100), 0) : 0;
//         const igstTotal = isSameState ? 0 : rows.reduce((sum, r) => sum + (parseFloat(r.IGST) * calcAmount(r) / 100), 0);
//         const taxableTotal = basic + cgstTotal + sgstTotal + igstTotal;
//         const finalAmount = taxableTotal;
//         // const roundedFinal = Math.ceil(finalAmount);
//         // const roundOff = roundedFinal - finalAmount;
//         const decimalPart = finalAmount - Math.floor(finalAmount);

//         const roundedFinal =
//             decimalPart >= 0.5
//                 ? Math.ceil(finalAmount)
//                 : Math.floor(finalAmount);

//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
//         console.log("taxable:", taxableTotal);

//         return {
//             basic: basic.toFixed(2),
//             discount: discount.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2),
//         };
//     };

//     const colorOptions = Object.entries(colorMap).map(([id, v]) => ({ id: +id, ...v }));
//     const sizeOptions = Object.entries(sizeMap).map(([id, v]) => ({ id: +id, ...v }));

//     useEffect(() => {
//         const dispatchQty = parseFloat(current.dispatchQty) || 0;
//         const rate = parseFloat(current.rate) || 0;
//         const disc = parseFloat(current.disc) || 0;
//         const amount = calcAmount({ dispatchQty, rate, disc });
//         setCurrent(prev => ({ ...prev, amount: amount.toFixed(2) }));
//     }, [current.dispatchQty, current.rate, current.disc]);

//     const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
//         const parsedDispatchQty = parseFloat(dispatchQty) || 0;
//         const parsedQty = parseFloat(qty) || 0;
//         let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? parseFloat(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? parseFloat(productMinLevel) : Infinity;
//         const minQty = 1;
//         const limit = Math.min(parsedQty, parsedMinLevel);
//         const isValid = Number.isFinite(parsedDispatchQty) && parsedDispatchQty >= minQty && parsedDispatchQty <= limit;
//         return { isValid, correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit)) };
//     };

//     const hasInvalidDispatchQty = () => {
//         const rowInvalid = rows.some(row => {
//             const product = productMap.get(row.productId);
//             const { isValid } = validateDispatchQty(row.dispatchQty, row.qty, row.minLevel, product?.minLevel);
//             return !isValid;
//         });
//         const currentInvalid = current.dispatchQty && !validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, productMap.get(current.Id)?.minLevel).isValid;
//         return rowInvalid || currentInvalid;
//     };

//     // const handleChange = field => e => {
//     //     const value = e.target.value;
//     //     setCurrent(prev => ({ ...prev, [field]: value }));
//     //     if (field === 'dispatchQty') {
//     //         const product = productMap.get(current.Id);
//     //         const { isValid } = validateDispatchQty(value, current.qty, current.minLevel, product?.minLevel);
//     //         setErrors(prev => ({ ...prev, dispatchQty: isValid ? undefined : `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}` }));
//     //     } else if (field === 'unit') {
//     //         setCurrent(prev => ({ ...prev, UnitId: unitMap.get(value) || null }));
//     //     }
//     // };

//     const handleChange = field => e => {
//         let value = e.target.value;

//         // Prevent increasing qty when editing an existing row
//         if (field === 'qty') {
//             let numeric = parseFloat(value) || 0;

//             if (editIndex != null && originalEditQty != null) {
//                 if (numeric > originalEditQty) {
//                     numeric = originalEditQty;
//                 }
//             }

//             setCurrent(prev => ({ ...prev, qty: numeric }));
//             return;
//         }

//         setCurrent(prev => ({ ...prev, [field]: value }));

//         if (field === 'dispatchQty') {
//             const product = productMap.get(current.Id);
//             const { isValid } = validateDispatchQty(value, current.qty, current.minLevel, product?.minLevel);
//             setErrors(prev => ({ ...prev, dispatchQty: isValid ? undefined : `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}` }));
//         } else if (field === 'unit') {
//             setCurrent(prev => ({ ...prev, UnitId: unitMap.get(value) || null }));
//         }
//     };

//     const handleSelect = product => {

//         if (mode === 'edit' && hasAnyPOReference()) {
//             setErrors({ global: 'Cannot add products because PO is already linked.' });
//             return;
//         }
//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && String(opt.UnitId) === String(product.UnitId)) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === String(product.Unit).toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === String(product.unit).toLowerCase()) return true;
//             return false;
//         });
//         const matchedColor = colorOptions.find(opt => opt.name.toLowerCase() === (product.color || '').toLowerCase());
//         const matchedSize = sizeOptions.find(opt => opt.name.toLowerCase() === (product.size || '').toLowerCase());
//         setCurrent({
//             Id: product.Id.toString(),
//             productCode: product.itemCode,
//             description: product.description,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId || ''),
//             unit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''),
//             qty: 1,
//             dispatchQty: 1,
//             rate: parseFloat(product.saleRate) || 0,
//             disc: parseFloat(product.saleDiscount) || 0,
//             tax: parseFloat(product.GST) || 0,
//             size: matchedSize?.name || '',
//             color: matchedColor?.name || '',
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: '',
//             remark: '',
//             minLevel: parseFloat(product.minLevel) || null,
//         });
//         setEditIndex(null);
//         setErrors({});
//     };

//     const addProduct = () => {
//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'unit', 'qty', 'dispatchQty',  'tax'];

//         let missingRequired = false;
//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 missingRequired = true;
//             }
//         });

//         if (missingRequired) {
//             messages.add('All fields are required.');
//         }

//         if (!current.qty || parseFloat(current.qty) <= 0) {
//             errs.qty = 'Must be > 0';
//             messages.add('Qty must be greater than 0');
//         }

//         if (Number(current.dispatchQty) <= 0) {
//             errs.dispatchQty = 'Must be > 0';
//             messages.add('Dispatch Qty must be greater than 0');
//         }

//         if (!current.rate || Number(current.rate) <= 0) {
//             errs.rate = 'Rate must be greater than 0';
//             messages.add('Rate must be greater than 0');
//         }

//         if (current.disc < 0 || current.disc > 100) {
//             errs.disc = 'Must be between 0 and 100';
//             messages.add('Discount must be between 0 and 100');
//         }

//         if (current.tax < 0) {
//             errs.tax = 'Cannot be negative';
//             messages.add('Tax cannot be negative');
//         }

//         const product = productMap.get(current.Id);
//         const { isValid, correctedValue } = validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, product?.minLevel);
//         if (!isValid) {
//             errs.dispatchQty = `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}`;
//             messages.add(errs.dispatchQty);
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }


//         const safeDisc =
//             current.disc === '' || current.disc == null
//                 ? 0
//                 : Number(current.disc);

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const amount = calcAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc });
//         const taxAmount = calcTaxAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc, tax: current.tax });

//         const row = {
//             ...current,
//             productId: current.Id,
//             UnitId: current.UnitId,
//             qty: parseFloat(current.qty),
//             rate: parseFloat(current.rate) || 0,
//             disc: safeDisc || 0,
//             tax: parseFloat(current.tax) || 0,
//             remark: current.remark || '',
//             GST: `${current.tax}%`,
//             CGST: isSameState ? (current.tax / 2).toString() : '0',
//             SGST: isSameState ? (current.tax / 2).toString() : '0',
//             IGST: isSameState ? '0' : current.tax.toString(),
//             UTGST: current.UTGST || '0',
//             GSTCess: current.GSTCess || '0',
//             saleRate: current.saleRate || '0',
//             saleDiscount: current.saleDiscount || '0',
//             amount,
//             taxAmount,
//             taxableAmount: amount,
//             POID: current.POID ?? null,
//             PODtsID: current.PODtsID ?? null,
//         };

//         const existingRowIndex = rows.findIndex(r => r.productCode === current.productCode);

//         if (existingRowIndex !== -1 && editIndex == null) {
//             setRows(prev => prev.map((r, i) => {
//                 if (i === existingRowIndex) {
//                     const mergedQty = parseFloat(r.qty) + parseFloat(current.qty);
//                     const mergedDispatchQty = parseFloat(r.dispatchQty) + parseFloat(current.dispatchQty);
//                     const mergedAmount = calcAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc) });
//                     const mergedTaxAmount = calcTaxAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc), tax: parseFloat(current.tax) });

//                     return {
//                         ...r,
//                         UnitId: current.UnitId ?? r.UnitId,
//                         unit: current.unit ?? r.unit,
//                         qty: mergedQty,
//                         dispatchQty: mergedDispatchQty,
//                         rate: parseFloat(current.rate) || r.rate,
//                         disc: parseFloat(current.disc) || r.disc,
//                         tax: parseFloat(current.tax) || r.tax,
//                         GST: `${current.tax}%`,
//                         CGST: isSameState ? (current.tax / 2).toString() : '0',
//                         SGST: isSameState ? (current.tax / 2).toString() : '0',
//                         IGST: isSameState ? '0' : current.tax.toString(),
//                         amount: mergedAmount,
//                         taxAmount: mergedTaxAmount,
//                         taxableAmount: mergedAmount,
//                         size: current.size || r.size || '',
//                         color: current.color || r.color || '',
//                         batchNo: current.batchNo || r.batchNo || '',
//                         expDate: current.expDate || r.expDate || '',
//                         serialNo: current.serialNo || r.serialNo || '',
//                         remark: current.remark || r.remark || '',
//                         minLevel: current.minLevel != null ? parseFloat(current.minLevel) : r.minLevel,
//                         SOID: r.SOID || null,
//                         SODtsID: r.SODtsID || null,
//                         srNo: r.srNo,
//                         id: r.srNo,
//                         POID: r.POID ?? current.POID ?? null,
//                         PODtsID: r.PODtsID ?? current.PODtsID ?? null,
//                     };
//                 }
//                 return r;
//             }));
//         } else {
//             row.srNo = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             row.id = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             if (editIndex != null) {
//                 setRows(prev => prev.map((r, i) => (i === editIndex ? { ...row } : r)));
//             } else {
//                 setRows((prev) => [row, ...prev]);
//                 setNextSrNo(prev => prev + 1);
//             }
//             setIsEditingMode(false);
//         }

//         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null });
//         setErrors({});
//         setEditIndex(null);
//         setOriginalEditQty(null);
//     };

//     // const editRow = idx => {
//     //     const row = rows[idx];
//     //     setCurrent({
//     //         ...row,
//     //         dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || 1,
//     //         minLevel: row.minLevel,
//     //         UnitId: row.UnitId || null,
//     //         POID: row.POID ?? row.POId ?? null,
//     //         PODtsID: row.PODtsID ?? row.PODtsId ?? null,
//     //     });
//     //     setEditIndex(idx);
//     // };

//     const editRow = idx => {
//         const row = rows[idx];
//         setCurrent({
//             ...row,
//             dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || 1,
//             minLevel: row.minLevel,
//             UnitId: row.UnitId || null,
//             POID: row.POID ?? row.POId ?? null,
//             PODtsID: row.PODtsID ?? row.PODtsId ?? null,
//         });
//         setEditIndex(idx);
//         setOriginalEditQty(parseFloat(row.qty) || 0);  // â† ADD THIS
//         setIsEditingMode(true);                         // â† ADD THIS
//     };

//     // const deleteRow = idx => {
//     //     setRows(prev => prev.filter((_, i) => i !== idx));
//     //     if (idx === editIndex) {
//     //         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null });
//     //         setEditIndex(null);
//     //         setErrors({});
//     //     }
//     // };

//     const deleteRow = idx => {
//         setRows(prev => prev.filter((_, i) => i !== idx));
//         if (idx === editIndex) {
//             setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null });
//             setEditIndex(null);
//             setErrors({});
//             setOriginalEditQty(null);  // â† ADD THIS
//         }
//     };

//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         if (hasInvalidDispatchQty()) {
//             setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
//             return;
//         }

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         const payloadRows = rows.map(r => {
//             const qty = Number(r.qty) || 0;
//             const dispatchQty = Number(r.dispatchQty) || 0;
//             const taxableAmount = calcAmount(r);
//             const taxAmount = calcTaxAmount(r);
//             const cgstRate = parseFloat(r.CGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
//             const sgstRate = parseFloat(r.SGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
//             const igstRate = parseFloat(r.IGST) || (isSameState ? 0 : parseFloat(r.tax));
//             const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//             const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//             const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//             return {
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 UnitId: r.UnitId,
//                 unit: r.unit,
//                 origQty: qty,                // <-- NEW: the original qty user expects to see in review
//                 origDispatchQty: dispatchQty,// <-- NEW: the original dispatch qty for review

//                 // For ref mode: send qty as-is (it's already the remaining qty from backend)
//                 // No need to add dispatchQty back since backend already calculated remaining
//                 qty: qty.toString(),
//                 dispatchQty: dispatchQty.toString(),
//                 rate: r.rate.toFixed(2),
//                 disc: r.disc.toFixed(2),
//                 CGST: cgstRate.toFixed(2),
//                 CGSTAmt: cgstAmt,
//                 SGST: sgstRate.toFixed(2),
//                 SGSTAmt: sgstAmt,
//                 IGST: igstRate.toFixed(2),
//                 IGSTAmt: igstAmt,
//                 TaxId: r.TaxId || 31,
//                 tax: parseFloat(r.tax),
//                 remark: r.remark || '',
//                 amount: taxableAmount.toFixed(2),
//                 taxAmount: taxAmount.toFixed(2),
//                 POID: r.POID ?? null,
//                 PODtsID: r.PODtsID ?? null,
//             };
//         });

//         const summarySection = {
//             totalProducts: rows.length,
//             totalDispatchQty: rows.reduce((sum, r) => sum + parseFloat(r.dispatchQty), 0),
//             products: rows.map(r => ({
//                 productCode: r.productCode,
//                 description: r.description,
//                 dispatchQty: r.dispatchQty.toString(),
//                 amount: calcAmount(r).toFixed(2),
//                 taxAmount: calcTaxAmount(r).toFixed(2),
//             })),
//         };

//         onNext({
//             tableData: payloadRows,
//             summary: totals,
//             summarySection,
//         });

//         console.log('Payload sent:', { tableData: payloadRows, summary: totals, summarySection });
//     };

//     const formatINR = val => parseFloat(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: true, filterable: true,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, CGST, SGST, IGST, size, color, batchNo, expDate, serialNo, remark, PONumber, PODate } = params.row;
//                 const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//                 const taxableAmount = calcAmount(params.row);
//                 const cgstRate = parseFloat(CGST) || (isSameState ? parseFloat(tax) / 2 : 0);
//                 const sgstRate = parseFloat(SGST) || (isSameState ? parseFloat(tax) / 2 : 0);
//                 const igstRate = parseFloat(IGST) || (isSameState ? 0 : parseFloat(tax));
//                 const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//                 const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//                 const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     editRow(params.row.index);
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography> */}
//                             <Tooltip
//                                 title={
//                                     mode === 'edit' && rowHasPOReference(params.row)
//                                         ? 'This Challan is created by reference.'
//                                         : mode === 'ref'
//                                             ? 'Cannot edit in reference mode.'
//                                             : ''
//                                 }
//                                 arrow
//                                 disableHoverListener={!(mode === 'edit' && rowHasPOReference(params.row)) && mode !== 'ref'}
//                             >
//                                 <span>
//                                     <Typography
//                                         variant="body2"
//                                         fontWeight="bold"
//                                         component="div"
//                                         sx={{
//                                             cursor: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? 'not-allowed'
//                                                 : 'pointer',
//                                             color: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? '#999'
//                                                 : '#1877F2',
//                                             textDecoration: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? 'none'
//                                                 : 'underline',
//                                             fontSize: '0.85rem'
//                                         }}
//                                         onClick={e => {
//                                             e.stopPropagation();
//                                             // DISABLE IF: edit mode with PO OR ref mode
//                                             if (!((mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref')) {
//                                                 editRow(params.row.index);
//                                             }
//                                         }}
//                                     >
//                                         {productCode}
//                                     </Typography>
//                                 </span>
//                             </Tooltip>
//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block"> Unit: {unit} | GST: {tax}% </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `CGST: ₹${formatINR(cgstAmt)} + SGST: ₹${formatINR(sgstAmt)}` : `IGST: ₹${formatINR(igstAmt)}`} </Typography>
//                         {(size || color) && (<Typography variant="caption" display="block"> {size && `Size: ${size}`} {color && `| Color: ${color}`} </Typography>)}
//                         {(PONumber || PODate) && (
//                             <Typography variant="caption" display="block" color='blue'>
//                                 {PONumber && `PONo: ${PONumber}`}
//                                 {PODate && ` | Date: ${PODate}`}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             },
//         },
//         { field: 'qty', headerName: 'Qty', width: 60, align: 'center', headerAlign: 'center', renderCell: params => params.row.qty },
//         {
//             field: 'dispatchQty',
//             headerName: 'Dispatch Qty',
//             width: 100,
//             align: 'center',
//             headerAlign: 'center',
//             renderCell: params => {
//                 const product = productMap.get(params.row.productId);
//                 const minLevel = params.row.minLevel === null ? Infinity : parseFloat(params.row.minLevel) || parseFloat(product?.minLevel) || Infinity;
//                 const { isValid, correctedValue } = validateDispatchQty(params.row.dispatchQty, params.row.qty, minLevel);

//                 // ============ ADD THIS LINE ============
//                 const isRowLocked = mode === 'edit' && rowHasPOReference(params.row);
//                 // ========================================

//                 return (
//                     <TextField
//                         type="number"
//                         size="small"
//                         value={params.row.dispatchQty}
//                         disabled={isRowLocked}  // â† ADD THIS
//                         inputProps={{ min: 0, max: Math.min(params.row.qty, minLevel), step: 'any' }}
//                         sx={{
//                             width: 80,
//                             '& .MuiOutlinedInput-root': { height: 32 },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: isValid ? undefined : 'red' },
//                         }}
//                         onChange={e => {
//                             if (isRowLocked) return;  // â† ADD THIS GUARD

//                             const raw = e.target.value;
//                             const v = parseFloat(raw);
//                             const updatedAmount = calcAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc
//                             });
//                             const updatedTaxAmount = calcTaxAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc,
//                                 tax: params.row.tax
//                             });
//                             setRows(prev => prev.map((r, i) => (i === params.row.index ? {
//                                 ...r,
//                                 dispatchQty: v,
//                                 amount: updatedAmount,
//                                 taxAmount: updatedTaxAmount,
//                                 taxableAmount: updatedAmount
//                             } : r)));
//                         }}
//                         onBlur={() => {
//                             if (isRowLocked) return;  // â† ADD THIS GUARD

//                             const limit = Math.min(params.row.qty, minLevel);
//                             let v = parseFloat(params.row.dispatchQty);
//                             if (!Number.isFinite(v) || v <= 0 || v > limit) {
//                                 v = correctedValue;
//                             }
//                             const updatedAmount = calcAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc
//                             });
//                             const updatedTaxAmount = calcTaxAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc,
//                                 tax: params.row.tax
//                             });
//                             setRows(prev => prev.map((r, i) => (i === params.row.index ? {
//                                 ...r,
//                                 dispatchQty: v,
//                                 amount: updatedAmount,
//                                 taxAmount: updatedTaxAmount,
//                                 taxableAmount: updatedAmount
//                             } : r)));
//                         }}
//                     />
//                 );
//             },
//         },
//         { field: 'rate', headerName: 'Rate', width: 90, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         {
//             field: 'disc', headerName: 'Disc', width: 50, align: 'center', headerAlign: 'center',
//             renderHeader: () => (
//                 <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
//                     <Typography variant="body2">Disc</Typography>
//                     <Typography variant="caption" color="text.secondary">(%)</Typography>
//                 </Box>
//             ),
//         },
//         { field: 'amount', headerName: 'Amount (₹)', width: 90, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(parseFloat(params.row.amount || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => (
//                 // <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error">
//                 //     <DeleteIcon fontSize="small" />
//                 // </IconButton>

//                 <IconButton
//                     size="small"
//                     onClick={() => deleteRow(params.row.index)}
//                     color="error"
//                     disabled={mode === 'edit' && rowHasPOReference(params.row) || mode === 'ref'}
//                 >
//                     <DeleteIcon fontSize="small" />
//                 </IconButton>

//             ),
//         },
//     ];

//     const rowHasPOReference = (row) => {
//         // console.log(row.PODtsId || row.PODtsID)
//         return (row.POId || row.POID) || (row.PODtsId || row.PODtsID);
//     };

//     // Check if ANY row has SO reference (for disabling add product button)
//     const hasAnyPOReference = () => {
//         return rows.some(r => rowHasPOReference(r));
//     };

//     const isAddProductDisabled = () => {
//         if (hasInvalidDispatchQty()) return true;
//         if (isEditingMode) return true;
//         if (mode === 'ref') return true;
//         if (mode === 'edit' && hasAnyPOReference()) return true;
//         return false;
//     };

//     return (
//         <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={1.5} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 1, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
//                     <Box>
//                         <DropdownProductCode id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} />
//                         {!!errors.productCode && <Typography color="error" variant="caption">{errors.productCode}</Typography>}
//                     </Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ my: -1.3 }}>
//                         Available Dispatch Qty: {current.minLevel === null ? 'N/A' : parseFloat(current.minLevel) || 'N/A'}
//                     </Typography>
//                     <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '0px 12px', minHeight: '80px' } }} />
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Unit" select required fullWidth size="small" value={current.unit} onChange={handleChange('unit')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} error={!!errors.unit} helperText={errors.unit} >
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u} value={u}>
//                                     {u}
//                                 </option>
//                             ))}
//                         </TextField>
//                         <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Qty" required size='small' fullWidth type="number" inputProps={{ min: 0, step: 'any' }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Rate"  size='small' fullWidth type="number" inputProps={{ min: 0 }} value={current.rate} onChange={handleChange('rate')} error={!!errors.rate} helperText={errors.rate} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Disc%" size='small' fullWidth type="number" inputProps={{ min: 0, max: 100 }} value={current.disc} onChange={handleChange('disc')} error={!!errors.disc} helperText={errors.disc} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <TextField label="Dispatch Qty" type="number" size="small" value={current.dispatchQty}
//                         inputProps={{ min: 1, max: Math.min(parseFloat(current.qty) || 1, current.minLevel === null ? (parseFloat(productMap.get(current.Id)?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity), step: 1 }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: errors.dispatchQty ? 'red' : undefined },
//                         }}
//                         onChange={handleChange('dispatchQty')}
//                         onBlur={() => {
//                             const product = productMap.get(current.Id);
//                             const minLevel = current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity;
//                             const limit = Math.min(parseFloat(current.qty) || 1, minLevel);
//                             const { isValid, correctedValue } = validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, product?.minLevel);
//                             if (!isValid) {
//                                 setCurrent(prev => ({ ...prev, dispatchQty: correctedValue }));
//                                 setErrors(prev => ({
//                                     ...prev,
//                                     dispatchQty: `Dispatch Qty must be greater than 0 and up to ${limit}`,
//                                 }));
//                             } else {
//                                 setErrors(prev => ({ ...prev, dispatchQty: undefined }));
//                             }
//                         }}
//                         error={!!errors.dispatchQty}
//                         helperText={errors.dispatchQty}
//                     />
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} />
//                     <Box display="flex" justifyContent="center">
//                         {/* <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={hasInvalidDispatchQty()}>
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button> */}
//                         <Button
//                             variant="outlined"
//                             onClick={addProduct}
//                             sx={{ minWidth: 180 }}
//                             disabled={
//                                 hasInvalidDispatchQty() ||
//                                 mode === 'ref' ||
//                                 (mode === 'edit' && hasAnyPOReference())
//                             }
//                         >
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>

//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
//                     {isMobile ? (
//                         <Box>
//                             {rows.map((row, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         border: "1px solid #cbd5e1",
//                                         borderRadius: 2,
//                                         p: 1.5,
//                                         mb: 1.5,
//                                         cursor: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref') ? 'not-allowed' : 'pointer',
//                                          color: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref')  && "text.disabled",
//                                     }}
//                                 >
//                                     <Typography sx={{ fontWeight: 600 }}>
//                                         {row.productCode} â€” <span style={{ fontStyle: "italic", fontWeight: "normal" }}>
//                                             {row.description}
//                                         </span>
//                                     </Typography>

//                                     {(row.PONumber || row.PODate) && (
//                                         <Typography variant="caption" display="block" color='blue'>
//                                             {row.PONumber && `PONo: ${row.PONumber}`}
//                                             {row.PODate && ` | Date: ${row.PODate}`}
//                                         </Typography>
//                                     )}

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Qty:</Typography>
//                                         <Typography>{row.qty}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Rate:</Typography>
//                                         <Typography>₹{row.rate}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Disc:</Typography>
//                                         <Typography>{row.disc}%</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Amount:</Typography>
//                                         <Typography>₹{row.amount}</Typography>
//                                     </Grid>

//                                     {/* DELETE / EDIT BUTTONS IF NEEDED */}
//                                     <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
//                                         <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
//                                             <EditIcon fontSize="small" />
//                                         </IconButton>
//                                         <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
//                                             <DeleteIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                     ) : (
//                         <DataGrid
//                             rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                             columns={columns}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             disableRowSelectionOnClick
//                             hideFooter
//                             sx={{
//                                 mt: 5,
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 1,
//                                 '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                                 '& .MuiDataGrid-columnHeader': { backgroundColor: '#f0f0f0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#edf2feff' },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#ffffff' }
//                             }}
//                         />
//                     )}
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state?.toLowerCase() === compState?.toLowerCase() ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                 <Typography>IGST</Typography>
//                                 <Typography>₹{formatINR(totals.igst)}</Typography>
//                             </Grid>
//                         )}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && <Typography color="error" sx={{ mt: 2 }}>{errors.global}</Typography>}
//             <Box mt={1} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={hasInvalidDispatchQty() || isEditingMode}>
//                     Next
//                 </Button>
//             </Box>
//         </Paper>
//     );
// };

// export default ProductDetails;





// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Tooltip } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import DropdownProductCode from './DropdownProductCode';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { useAuth } from '../../../context/AuthContext';
// import axios from 'axios';
// import EditIcon from '@mui/icons-material/Edit';

// const ProductDetails = ({ initialData, onNext, clientData, connectionString, mode, isFinalLocked }) => {
//     const { user, selectedCompany, loading } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const state = clientData?.details?.['State'];
//     const compState = selectedCompany?.State;
//     console.log(state, compState);
//     const theme = useTheme();
//     const isSmall = useMediaQuery(theme.breakpoints.down('md'));
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const [rows, setRows] = useState([]);
//     const [nextSrNo, setNextSrNo] = useState(1);
//     const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : '', dispatchQty: 1, rate: '', disc: '', tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null });
//     const [errors, setErrors] = useState({});
//     const [editIndex, setEditIndex] = useState(null);
//     const [allProducts, setAllProducts] = useState([]);
//     const [productMap, setProductMap] = useState(new Map());
//     const [unitOptions, setUnitOptions] = useState([]);
//     const [unitMap, setUnitMap] = useState(new Map());
//     const [colorMap, setColorMap] = useState({});
//     const [sizeMap, setSizeMap] = useState({});
//     const [totals, setTotals] = useState({ basic: '0.00', discount: '0.00', cgst: '0.00', sgst: '0.00', igst: '0.00', roundOff: '0.00', total: '0.00' });
//     const [originalEditQty, setOriginalEditQty] = useState(null);
//     const [isEditingMode, setIsEditingMode] = useState(false);

//     const rowIsInvoiceLocked = (row) => {
//         return mode === 'edit' && isFinalLocked && row.challanDtsID;
//     };

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const rowsRef = useRef([]);
//     useEffect(() => {
//         rowsRef.current = rows;
//     }, [rows]);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const [unitsRes, cRes, sRes] = await Promise.all([
//                     axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } }),
//                     axios.get(`${connectionString}/api/colormaster`),
//                     axios.get(`${connectionString}/api/sizemaster`),
//                 ]);
//                 const unitsData = unitsRes?.data || [];
//                 const units = unitsData.map(u => u.unit);
//                 const unitIdMap = new Map(unitsData.map(u => [u.unit, u.UnitId]));
//                 setUnitOptions(units);
//                 setUnitMap(unitIdMap);
//                 const cm = {}, sm = {};
//                 cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
//                 sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
//                 setColorMap(cm);
//                 setSizeMap(sm);
//             } catch (error) {
//                 console.error('Error fetching product or unit data:', error);
//             }
//         };
//         fetchData();
//         loadAllProducts();
//     }, []);

//     const loadAllProducts = async () => {
//         try {
//             const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params: { companyId } });
//             setAllProducts(res.data || []);
//             setProductMap(new Map(res.data.map(p => [p.Id, p])));
//         } catch (e) {
//             console.error('Error loading products:', e);
//         }
//     };

//     useEffect(() => {
//         if (!initialData?.tableData || !Array.isArray(initialData.tableData)) {
//             if (rowsRef.current.length > 0) {
//                 setRows(rowsRef.current);
//             }
//             return;
//         }
//         console.log("init data:", initialData);

//         const isEditMode = initialData.tableData.some(r => r.challanDtsID || r.challanID);
//         console.log("Detected Mode:", isEditMode ? "Edit" : "Ref");

//         const initialRows = initialData.tableData.map((r, index) => {
//             let qty, dispatchQty;

//             if (mode === 'edit') {
//                 // For edit mode: use raw values from database directly
//                 qty = Number(r.qty) || 1;
//                 dispatchQty = Number(r.dispQty) || Number(r.dispatchQty) || 1;
//                 console.log(r.dispQty);
//             } else {
//                 // For ref/add mode: Backend already calculates remaining qty
//                 // qty = remaining quantity (originalQty - challanDispatchedQty)
//                 // dispatchQty = remaining quantity (same as qty, what can be dispatched)
//                 // Use the values directly from backend - they are already the remaining quantities
//                 qty = Number(r.qty) || 0;
//                 dispatchQty = Number(r.dispatchQty) || Number(r.qty) || 0;

//                 // If qty is 0, it means fully dispatched - this shouldn't happen as backend filters it out
//                 // But as a safety net, set minimum to 1 only if qty > 0
//                 if (qty === 0) {
//                     console.warn(`Product ${r.productCode} has 0 qty - should have been filtered by backend`);
//                 }
//             }

//             const rate = parseFloat(r.rate) || 0;
//             const disc = parseFloat(r.disc) || 0;
//             const amount = parseFloat((dispatchQty * rate * (1 - disc / 100)).toFixed(2));

//             const gst = parseFloat(r.GST) || 0;
//             const cgst = parseFloat(r.CGST) || 0;
//             const sgst = parseFloat(r.SGST) || 0;
//             const igst = parseFloat(r.IGST) || 0;
//             const taxPercent = gst || (cgst + sgst) || igst || 0;

//             let unitName = '';
//             if (r.unit && r.unit.toString().trim()) {
//                 unitName = r.unit.toString().trim();
//             } else if (r.Unit && r.Unit.toString().trim()) {
//                 unitName = r.Unit.toString().trim();
//             } else if (r.UnitId) {
//                 unitName = Array.from(unitMap.entries()).find(([_, id]) => String(id) === String(r.UnitId))?.[0] || '';
//             }

//             const POID = r.POID ?? r.POId ?? r.POID ?? null;
//             const PODtsID = r.PODtsID ?? r.PODtsId ?? r.PODtsID ?? null;

//             const row = {
//                 ...r,
//                 productId: r.productId || r.Id || r.id,
//                 UnitId: r.UnitId || null,
//                 unit: unitName,
//                 qty: qty,
//                 dispatchQty: dispatchQty,
//                 rate,
//                 disc,
//                 tax: taxPercent,
//                 amount,
//                 taxAmount: parseFloat((amount * taxPercent / 100).toFixed(2)),
//                 taxableAmount: amount,
//                 minLevel: r.minLevel === null ? null : parseFloat(r.minLevel) || Infinity,
//                 srNo: initialData.tableData.length - index,
//                 id: initialData.tableData.length - index,
//                 GST: `${taxPercent}%`,
//                 CGST: cgst.toString(),
//                 SGST: sgst.toString(),
//                 IGST: igst.toString(),
//                 POID,
//                 PODtsID,
//                 // Store original values for reference
//                 originalQty: Number(r.originalQty) || qty,
//                 challanDispatchedQty: Number(r.challanDispatchedQty) || 0,
//             };

//             console.log(`Loading row (Mode: ${isEditMode ? 'Edit' : 'Ref'}): qty=${qty}, dispatchQty=${dispatchQty}, POID=${POID}, PODtsID=${PODtsID}, originalQty=${r.originalQty}, challanDispatchedQty=${r.challanDispatchedQty}`);
//             return row;
//         });

//         setRows(initialRows);
//         setNextSrNo(initialRows.length + 1);
//     }, [initialData?.tableData, unitMap]);

//     useEffect(() => {
//         setTotals(calculateTotals());
//     }, [rows, state, compState]);

//     const calcAmount = ({ dispatchQty, rate, disc }) => parseFloat((dispatchQty * rate * (1 - disc / 100)).toFixed(2));
//     const calcTaxAmount = ({ dispatchQty, rate, disc, tax }) => parseFloat((dispatchQty * rate * (1 - disc / 100) * (tax / 100)).toFixed(2));

//     const calculateTotals = () => {
//         const basic = rows.reduce((sum, r) => sum + calcAmount(r), 0);
//         const discount = rows.reduce((sum, r) => sum + (r.dispatchQty * r.rate * (r.disc / 100)), 0);
//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const cgstTotal = isSameState ? rows.reduce((sum, r) => sum + (parseFloat(r.CGST) * calcAmount(r) / 100), 0) : 0;
//         const sgstTotal = isSameState ? rows.reduce((sum, r) => sum + (parseFloat(r.SGST) * calcAmount(r) / 100), 0) : 0;
//         const igstTotal = isSameState ? 0 : rows.reduce((sum, r) => sum + (parseFloat(r.IGST) * calcAmount(r) / 100), 0);
//         const taxableTotal = basic + cgstTotal + sgstTotal + igstTotal;
//         const finalAmount = taxableTotal;
//         // const roundedFinal = Math.ceil(finalAmount);
//         // const roundOff = roundedFinal - finalAmount;
//         const decimalPart = finalAmount - Math.floor(finalAmount);

//         const roundedFinal =
//             decimalPart >= 0.5
//                 ? Math.ceil(finalAmount)
//                 : Math.floor(finalAmount);

//         const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
//         console.log("taxable:", taxableTotal);

//         return {
//             basic: basic.toFixed(2),
//             discount: discount.toFixed(2),
//             cgst: cgstTotal.toFixed(2),
//             sgst: sgstTotal.toFixed(2),
//             igst: igstTotal.toFixed(2),
//             roundOff: roundOff.toFixed(2),
//             total: roundedFinal.toFixed(2),
//         };
//     };

//     const colorOptions = Object.entries(colorMap).map(([id, v]) => ({ id: +id, ...v }));
//     const sizeOptions = Object.entries(sizeMap).map(([id, v]) => ({ id: +id, ...v }));

//     useEffect(() => {
//         const dispatchQty = parseFloat(current.dispatchQty) || 0;
//         const rate = parseFloat(current.rate) || 0;
//         const disc = parseFloat(current.disc) || 0;
//         const amount = calcAmount({ dispatchQty, rate, disc });
//         setCurrent(prev => ({ ...prev, amount: amount.toFixed(2) }));
//     }, [current.dispatchQty, current.rate, current.disc]);

//     // const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
//     //     const parsedDispatchQty = parseFloat(dispatchQty) || 0;
//     //     const parsedQty = parseFloat(qty) || 0;
//     //     let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? parseFloat(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? parseFloat(productMinLevel) : Infinity;
//     //     const minQty = 1;
//     //     const limit = Math.min(parsedQty, parsedMinLevel);
//     //     const isValid = Number.isFinite(parsedDispatchQty) && parsedDispatchQty >= minQty && parsedDispatchQty <= limit;
//     //     return { isValid, correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit)) };
//     // };

//     const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
//         const parsedDispatchQty = Number(dispatchQty) || 0;
//         const parsedQty = Number(qty) || 0;

//         let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? Number(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? Number(productMinLevel) : Infinity;

//         const minQty = '';

//         // ðŸ”¥ CHANGE ONLY THIS PART
//         let limit;

//         if (mode === 'add') {
//             limit = parsedMinLevel;
//         }
//         else if (mode === 'edit') {
//             limit = Math.min(parsedQty, parsedMinLevel);
//         }
//         else if (mode === 'ref') {
//             // ðŸ”¥ In ref mode â†’ Dispatch Qty cannot exceed SO Qty
//             limit = Math.min(parsedQty, parsedMinLevel);
//         }

//         const isValid =
//             Number.isFinite(parsedDispatchQty) &&
//             parsedDispatchQty >= minQty &&
//             parsedDispatchQty <= limit;

//         return {
//             isValid,
//             correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit))
//         };
//     };

//     // const hasInvalidDispatchQty = () => {
//     //     const rowInvalid = rows.some(row => {
//     //         const product = productMap.get(row.productId);
//     //         const { isValid } = validateDispatchQty(row.dispatchQty, row.qty, row.minLevel, product?.minLevel);
//     //         return !isValid;
//     //     });
//     //     const currentInvalid = current.dispatchQty && !validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, productMap.get(current.Id)?.minLevel).isValid;
//     //     return rowInvalid || currentInvalid;
//     // };

//     const hasInvalidDispatchQty = () => {
//         const rowInvalid = rows.some(row => {

//             const hasPORef =
//                 mode === 'edit' &&
//                 rowHasPOReference(row);

//             // ðŸ”¥ Skip validation if edit mode without SO
//             if (mode === 'edit' && !hasPORef) {
//                 return false;
//             }

//             const product = productMap.get(row.productId);

//             const { isValid } = validateDispatchQty(
//                 row.dispatchQty,
//                 row.qty,
//                 row.minLevel,
//                 product?.minLevel
//             );

//             return !isValid;
//         });

//         const currentInvalid =
//             mode === 'edit' && !rowHasPOReference(current)
//                 ? false
//                 : current.dispatchQty &&
//                 !validateDispatchQty(
//                     current.dispatchQty,
//                     current.qty,
//                     current.minLevel,
//                     productMap.get(current.Id)?.minLevel
//                 ).isValid;

//         return rowInvalid || currentInvalid;
//     };

//     const handleChange = field => e => {
//         let value = e.target.value;

//         // Prevent increasing qty when editing an existing row
//         if (field === 'qty') {
//             let numeric = parseFloat(value) || 0;

//             if (editIndex != null && originalEditQty != null) {
//                 if (numeric > originalEditQty) {
//                     numeric = originalEditQty;
//                 }
//             }

//             setCurrent(prev => ({ ...prev, qty: numeric }));
//             return;
//         }

//         setCurrent(prev => ({ ...prev, [field]: value }));

//         if (field === 'dispatchQty') {
//             const product = productMap.get(current.Id);
//             const { isValid } = validateDispatchQty(value, current.qty, current.minLevel, product?.minLevel);
//             setErrors(prev => ({ ...prev, dispatchQty: isValid ? undefined : `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}` }));
//         } else if (field === 'unit') {
//             setCurrent(prev => ({ ...prev, UnitId: unitMap.get(value) || null }));
//         }
//     };

//     const handleSelect = product => {

//         if (mode === 'edit' && hasAnyPOReference()) {
//             setErrors({ global: 'Cannot add products because PO is already linked.' });
//             return;
//         }
//         const matchedUnit = unitOptions.find(opt => {
//             if (product.UnitId && String(opt.UnitId) === String(product.UnitId)) return true;
//             if (product.Unit && opt.unit?.toLowerCase() === String(product.Unit).toLowerCase()) return true;
//             if (product.unit && opt.unit?.toLowerCase() === String(product.unit).toLowerCase()) return true;
//             return false;
//         });
//         const matchedColor = colorOptions.find(opt => opt.name.toLowerCase() === (product.color || '').toLowerCase());
//         const matchedSize = sizeOptions.find(opt => opt.name.toLowerCase() === (product.size || '').toLowerCase());
//         setCurrent({
//             Id: product.Id.toString(),
//             productCode: product.itemCode,
//             description: product.description,
//             UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId || ''),
//             unit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''),
//             qty: 1,
//             dispatchQty: 1,
//             rate: parseFloat(product.saleRate) || 0,
//             disc: parseFloat(product.saleDiscount) || 0,
//             tax: parseFloat(product.GST) || 0,
//             size: matchedSize?.name || '',
//             color: matchedColor?.name || '',
//             batchNo: '',
//             expDate: '',
//             serialNo: '',
//             amount: '',
//             remark: '',
//             minLevel: parseFloat(product.minLevel) || null,
//         });
//         setEditIndex(null);
//         setErrors({});
//     };

//     const addProduct = () => {
//         const errs = {};
//         const messages = new Set();
//         const requiredFields = ['productCode', 'description', 'unit', 'qty', 'dispatchQty', 'tax'];

//         let missingRequired = false;
//         requiredFields.forEach(field => {
//             if (!current[field] && current[field] !== 0) {
//                 errs[field] = 'Required';
//                 missingRequired = true;
//             }
//         });

//         if (missingRequired) {
//             messages.add('All fields are required.');
//         }

//         if (!current.qty || parseFloat(current.qty) <= 0) {
//             errs.qty = 'Must be > 0';
//             messages.add('Qty must be greater than 0');
//         }

//         if (Number(current.dispatchQty) <= 0) {
//             errs.dispatchQty = 'Must be > 0';
//             messages.add('Dispatch Qty must be greater than 0');
//         }

//         if (!current.rate || Number(current.rate) <= 0) {
//             errs.rate = 'Rate must be greater than 0';
//             messages.add('Rate must be greater than 0');
//         }

//         if (current.disc < 0 || current.disc > 100) {
//             errs.disc = 'Must be between 0 and 100';
//             messages.add('Discount must be between 0 and 100');
//         }

//         if (current.tax < 0) {
//             errs.tax = 'Cannot be negative';
//             messages.add('Tax cannot be negative');
//         }

//         const product = productMap.get(current.Id);
//         const { isValid, correctedValue } = validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, product?.minLevel);
//         if (!isValid) {
//             errs.dispatchQty = `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}`;
//             messages.add(errs.dispatchQty);
//         }

//         if (messages.size > 0) {
//             errs.global = Array.from(messages);
//             setErrors(errs);
//             return;
//         }


//         const safeDisc =
//             current.disc === '' || current.disc == null
//                 ? 0
//                 : Number(current.disc);

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//         const amount = calcAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc });
//         const taxAmount = calcTaxAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc, tax: current.tax });

//         const row = {
//             ...current,
//             productId: current.Id,
//             UnitId: current.UnitId,
//             qty: parseFloat(current.qty),
//             rate: parseFloat(current.rate) || 0,
//             disc: safeDisc || 0,
//             tax: parseFloat(current.tax) || 0,
//             remark: current.remark || '',
//             GST: `${current.tax}%`,
//             CGST: isSameState ? (current.tax / 2).toString() : '0',
//             SGST: isSameState ? (current.tax / 2).toString() : '0',
//             IGST: isSameState ? '0' : current.tax.toString(),
//             UTGST: current.UTGST || '0',
//             GSTCess: current.GSTCess || '0',
//             saleRate: current.saleRate || '0',
//             saleDiscount: current.saleDiscount || '0',
//             amount,
//             taxAmount,
//             taxableAmount: amount,
//             POID: current.POID ?? null,
//             PODtsID: current.PODtsID ?? null,
//         };

//         const existingRowIndex = rows.findIndex(r => r.productCode === current.productCode);

//         if (existingRowIndex !== -1 && editIndex == null) {
//             setRows(prev => prev.map((r, i) => {
//                 if (i === existingRowIndex) {
//                     const mergedQty = parseFloat(r.qty) + parseFloat(current.qty);
//                     const mergedDispatchQty = parseFloat(r.dispatchQty) + parseFloat(current.dispatchQty);
//                     const mergedAmount = calcAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc) });
//                     const mergedTaxAmount = calcTaxAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc), tax: parseFloat(current.tax) });

//                     return {
//                         ...r,
//                         UnitId: current.UnitId ?? r.UnitId,
//                         unit: current.unit ?? r.unit,
//                         qty: mergedQty,
//                         dispatchQty: mergedDispatchQty,
//                         rate: parseFloat(current.rate) || r.rate,
//                         disc: parseFloat(current.disc) || r.disc,
//                         tax: parseFloat(current.tax) || r.tax,
//                         GST: `${current.tax}%`,
//                         CGST: isSameState ? (current.tax / 2).toString() : '0',
//                         SGST: isSameState ? (current.tax / 2).toString() : '0',
//                         IGST: isSameState ? '0' : current.tax.toString(),
//                         amount: mergedAmount,
//                         taxAmount: mergedTaxAmount,
//                         taxableAmount: mergedAmount,
//                         size: current.size || r.size || '',
//                         color: current.color || r.color || '',
//                         batchNo: current.batchNo || r.batchNo || '',
//                         expDate: current.expDate || r.expDate || '',
//                         serialNo: current.serialNo || r.serialNo || '',
//                         remark: current.remark || r.remark || '',
//                         minLevel: current.minLevel != null ? parseFloat(current.minLevel) : r.minLevel,
//                         SOID: r.SOID || null,
//                         SODtsID: r.SODtsID || null,
//                         srNo: r.srNo,
//                         id: r.srNo,
//                         POID: r.POID ?? current.POID ?? null,
//                         PODtsID: r.PODtsID ?? current.PODtsID ?? null,
//                     };
//                 }
//                 return r;
//             }));
//         } else {
//             row.srNo = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             row.id = editIndex != null ? rows[editIndex].srNo : nextSrNo;
//             if (editIndex != null) {
//                 setRows(prev => prev.map((r, i) => (i === editIndex ? { ...row } : r)));
//             } else {
//                 setRows((prev) => [row, ...prev]);
//                 setNextSrNo(prev => prev + 1);
//             }
//             setIsEditingMode(false);
//         }

//         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null });
//         setErrors({});
//         setEditIndex(null);
//         setOriginalEditQty(null);
//     };

//     // const editRow = idx => {
//     //     const row = rows[idx];
//     //     setCurrent({
//     //         ...row,
//     //         dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || 1,
//     //         minLevel: row.minLevel,
//     //         UnitId: row.UnitId || null,
//     //         POID: row.POID ?? row.POId ?? null,
//     //         PODtsID: row.PODtsID ?? row.PODtsId ?? null,
//     //     });
//     //     setEditIndex(idx);
//     //     setOriginalEditQty(parseFloat(row.qty) || 0);  // â† ADD THIS
//     //     setIsEditingMode(true);                         // â† ADD THIS
//     // };

//     const editRow = idx => {
//         const row = rows[idx];

//         // âœ… ADD THIS BLOCK ONLY
//         if (
//             mode === 'edit' &&
//             (rowHasPOReference(row) || rowIsInvoiceLocked(row))
//         ) {
//             setErrors({ global: 'Cannot edit this product. Challan already created.' });
//             return;
//         }

//         // â¬‡ï¸ KEEP YOUR EXISTING CODE BELOW
//         setCurrent({
//             ...row,
//             dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || 1,
//             minLevel: row.minLevel,
//             UnitId: row.UnitId || null,
//             POID: row.POID ?? row.POId ?? null,
//             PODtsID: row.PODtsID ?? row.PODtsId ?? null,
//         });

//         setEditIndex(idx);
//         setOriginalEditQty(parseFloat(row.qty) || 0);
//         setIsEditingMode(true);
//     };

//     // const deleteRow = idx => {
//     //     setRows(prev => prev.filter((_, i) => i !== idx));
//     //     if (idx === editIndex) {
//     //         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null });
//     //         setEditIndex(null);
//     //         setErrors({});
//     //         setOriginalEditQty(null);  // â† ADD THIS
//     //     }
//     // };

//     const deleteRow = idx => {
//         const row = rows[idx];

//         // âœ… ADD THIS CONDITION
//         if (mode === 'edit' && rowHasPOReference(row)) {
//             setErrors({ global: 'Cannot delete products with PO reference in edit mode.' });
//             return;
//         }

//         // â¬‡ï¸ KEEP YOUR EXISTING LOGIC
//         setRows(prev => prev.filter((_, i) => i !== idx));

//         if (idx === editIndex) {
//             setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null });
//             setEditIndex(null);
//             setErrors({});
//             setOriginalEditQty(null);
//         }
//     };

//     const handleNext = () => {
//         if (rows.length === 0) {
//             setErrors({ global: 'Add at least one product' });
//             return;
//         }

//         if (hasInvalidDispatchQty()) {
//             setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
//             return;
//         }

//         const isSameState = state?.toLowerCase() === compState?.toLowerCase();

//         const payloadRows = rows.map(r => {
//             const qty = Number(r.qty) || 0;
//             const dispatchQty = Number(r.dispatchQty) || 0;
//             const taxableAmount = calcAmount(r);
//             const taxAmount = calcTaxAmount(r);
//             const cgstRate = parseFloat(r.CGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
//             const sgstRate = parseFloat(r.SGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
//             const igstRate = parseFloat(r.IGST) || (isSameState ? 0 : parseFloat(r.tax));
//             const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//             const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//             const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//             return {
//                 productId: r.productId,
//                 productCode: r.productCode,
//                 description: r.description,
//                 UnitId: r.UnitId,
//                 unit: r.unit,
//                 origQty: qty,                // <-- NEW: the original qty user expects to see in review
//                 origDispatchQty: dispatchQty,// <-- NEW: the original dispatch qty for review

//                 // For ref mode: send qty as-is (it's already the remaining qty from backend)
//                 // No need to add dispatchQty back since backend already calculated remaining
//                 qty: qty.toString(),
//                 dispatchQty: dispatchQty.toString(),
//                 rate: r.rate.toFixed(2),
//                 disc: r.disc.toFixed(2),
//                 CGST: cgstRate.toFixed(2),
//                 CGSTAmt: cgstAmt,
//                 SGST: sgstRate.toFixed(2),
//                 SGSTAmt: sgstAmt,
//                 IGST: igstRate.toFixed(2),
//                 IGSTAmt: igstAmt,
//                 TaxId: r.TaxId || 31,
//                 tax: parseFloat(r.tax),
//                 remark: r.remark || '',
//                 amount: taxableAmount.toFixed(2),
//                 taxAmount: taxAmount.toFixed(2),
//                 POID: r.POID ?? null,
//                 PODtsID: r.PODtsID ?? null,
//             };
//         });

//         const summarySection = {
//             totalProducts: rows.length,
//             totalDispatchQty: rows.reduce((sum, r) => sum + parseFloat(r.dispatchQty), 0),
//             products: rows.map(r => ({
//                 productCode: r.productCode,
//                 description: r.description,
//                 dispatchQty: r.dispatchQty.toString(),
//                 amount: calcAmount(r).toFixed(2),
//                 taxAmount: calcTaxAmount(r).toFixed(2),
//             })),
//         };

//         onNext({
//             tableData: payloadRows,
//             summary: totals,
//             summarySection,
//         });

//         console.log('Payload sent:', { tableData: payloadRows, summary: totals, summarySection });
//     };

//     const formatINR = val => parseFloat(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     const columns = [
//         { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
//         {
//             field: 'product', headerName: 'Product', flex: 1, sortable: true, filterable: true,
//             renderCell: params => {
//                 const { productCode, description, unit, tax, CGST, SGST, IGST, size, color, batchNo, expDate, serialNo, remark, PONumber, PODate } = params.row;
//                 const isSameState = state?.toLowerCase() === compState?.toLowerCase();
//                 const taxableAmount = calcAmount(params.row);
//                 const cgstRate = parseFloat(CGST) || (isSameState ? parseFloat(tax) / 2 : 0);
//                 const sgstRate = parseFloat(SGST) || (isSameState ? parseFloat(tax) / 2 : 0);
//                 const igstRate = parseFloat(IGST) || (isSameState ? 0 : parseFloat(tax));
//                 const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
//                 const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
//                 const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

//                 return (
//                     <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
//                         <Box>
//                             {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
//                                 onClick={e => {
//                                     e.stopPropagation();
//                                     editRow(params.row.index);
//                                 }}
//                             >
//                                 {productCode}
//                             </Typography> */}
//                             <Tooltip
//                                 title={
//                                     mode === 'edit' && rowHasPOReference(params.row)
//                                         ? 'This Challan is created by reference.'
//                                         : mode === 'ref'
//                                             ? 'Cannot edit in reference mode.'
//                                             : ''
//                                 }
//                                 arrow
//                                 disableHoverListener={!(mode === 'edit' && rowHasPOReference(params.row)) && mode !== 'ref'}
//                             >
//                                 <span>
//                                     <Typography
//                                         variant="body2"
//                                         fontWeight="bold"
//                                         component="div"
//                                         sx={{
//                                             cursor: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? 'not-allowed'
//                                                 : 'pointer',
//                                             color: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? '#999'
//                                                 : '#1877F2',
//                                             textDecoration: (mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref'
//                                                 ? 'none'
//                                                 : 'underline',
//                                             fontSize: '0.85rem'
//                                         }}
//                                         onClick={e => {
//                                             e.stopPropagation();
//                                             // DISABLE IF: edit mode with PO OR ref mode
//                                             if (!((mode === 'edit' && rowHasPOReference(params.row)) || mode === 'ref')) {
//                                                 editRow(params.row.index);
//                                             }
//                                         }}
//                                     >
//                                         {productCode}
//                                     </Typography>
//                                 </span>
//                             </Tooltip>
//                             <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
//                                 {description}
//                             </Typography>
//                         </Box>
//                         <Typography variant="caption" display="block"> Unit: {unit} | GST: {tax}% </Typography>
//                         <Typography variant="caption" display="block" color="text.secondary">
//                             {isSameState ? `CGST: ₹${formatINR(cgstAmt)} + SGST: ₹${formatINR(sgstAmt)}` : `IGST: ₹${formatINR(igstAmt)}`} </Typography>
//                         {(size || color) && (<Typography variant="caption" display="block"> {size && `Size: ${size}`} {color && `| Color: ${color}`} </Typography>)}
//                         {(PONumber || PODate) && (
//                             <Typography variant="caption" display="block" color='blue'>
//                                 {PONumber && `PONo: ${PONumber}`}
//                                 {PODate && ` | Date: ${PODate}`}
//                             </Typography>
//                         )}
//                     </Box>
//                 );
//             },
//         },
//         { field: 'qty', headerName: 'Qty', width: 60, align: 'center', headerAlign: 'center', renderCell: params => params.row.qty },
//         {
//             field: 'dispatchQty',
//             headerName: 'Dispatch Qty',
//             width: 100,
//             align: 'center',
//             headerAlign: 'center',
//             renderCell: params => {
//                 const product = productMap.get(params.row.productId);
//                 const minLevel = params.row.minLevel === null ? Infinity : parseFloat(params.row.minLevel) || parseFloat(product?.minLevel) || Infinity;
//                 const { isValid, correctedValue } = validateDispatchQty(params.row.dispatchQty, params.row.qty, minLevel);

//                 // ============ ADD THIS LINE ============
//                 const isRowLocked = mode === 'edit' && rowHasPOReference(params.row);
//                 // ========================================

//                 return (
//                     <TextField
//                         type="number"
//                         size="small"
//                         value={params.row.dispatchQty}
//                         disabled={isRowLocked}  // â† ADD THIS
//                         inputProps={{ min: 0, max: Math.min(params.row.qty, minLevel), step: 'any' }}
//                         sx={{
//                             width: 80,
//                             '& .MuiOutlinedInput-root': { height: 32 },
//                             '& .MuiOutlinedInput-notchedOutline': { borderColor: isValid ? undefined : 'red' },
//                         }}
//                         onChange={e => {
//                             if (isRowLocked) return;  // â† ADD THIS GUARD

//                             const raw = e.target.value;
//                             const v = parseFloat(raw);
//                             const updatedAmount = calcAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc
//                             });
//                             const updatedTaxAmount = calcTaxAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc,
//                                 tax: params.row.tax
//                             });
//                             setRows(prev => prev.map((r, i) => (i === params.row.index ? {
//                                 ...r,
//                                 dispatchQty: v,
//                                 amount: updatedAmount,
//                                 taxAmount: updatedTaxAmount,
//                                 taxableAmount: updatedAmount
//                             } : r)));
//                         }}
//                         onBlur={() => {
//                             if (isRowLocked) return;  // â† ADD THIS GUARD

//                             const limit = Math.min(params.row.qty, minLevel);
//                             let v = parseFloat(params.row.dispatchQty);
//                             if (!Number.isFinite(v) || v <= 0 || v > limit) {
//                                 v = correctedValue;
//                             }
//                             const updatedAmount = calcAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc
//                             });
//                             const updatedTaxAmount = calcTaxAmount({
//                                 dispatchQty: v,
//                                 rate: params.row.rate,
//                                 disc: params.row.disc,
//                                 tax: params.row.tax
//                             });
//                             setRows(prev => prev.map((r, i) => (i === params.row.index ? {
//                                 ...r,
//                                 dispatchQty: v,
//                                 amount: updatedAmount,
//                                 taxAmount: updatedTaxAmount,
//                                 taxableAmount: updatedAmount
//                             } : r)));
//                         }}
//                     />
//                 );
//             },
//         },
//         { field: 'rate', headerName: 'Rate', width: 90, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
//         {
//             field: 'disc', headerName: 'Disc', width: 50, align: 'center', headerAlign: 'center',
//             renderHeader: () => (
//                 <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
//                     <Typography variant="body2">Disc</Typography>
//                     <Typography variant="caption" color="text.secondary">(%)</Typography>
//                 </Box>
//             ),
//         },
//         { field: 'amount', headerName: 'Amount (₹)', width: 90, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(parseFloat(params.row.amount || 0))}` },
//         {
//             width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
//             renderCell: params => (
//                 // <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error">
//                 //     <DeleteIcon fontSize="small" />
//                 // </IconButton>

//                 <IconButton
//                     size="small"
//                     onClick={() => deleteRow(params.row.index)}
//                     color="error"
//                     disabled={mode === 'edit' && rowHasPOReference(params.row) || mode === 'ref'}
//                 >
//                     <DeleteIcon fontSize="small" />
//                 </IconButton>

//             ),
//         },
//     ];

//     const rowHasPOReference = (row) => {
//         // console.log(row.PODtsId || row.PODtsID)
//         return (row.POId || row.POID) || (row.PODtsId || row.PODtsID);
//     };

//     // Check if ANY row has SO reference (for disabling add product button)
//     const hasAnyPOReference = () => {
//         return rows.some(r => rowHasPOReference(r));
//     };

//     const isAddProductDisabled = () => {
//         if (hasInvalidDispatchQty()) return true;
//         if (isEditingMode) return true;
//         if (mode === 'ref') return true;
//         if (mode === 'edit' && hasAnyPOReference()) return true;
//         return false;
//     };

//     return (
//         <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
//                 <Box display="flex" flexDirection="column" gap={1.5} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 1, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
//                     <Box>
//                         <DropdownProductCode id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} />
//                         {!!errors.productCode && <Typography color="error" variant="caption">{errors.productCode}</Typography>}
//                     </Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ my: -1.3 }}>
//                         Available Dispatch Qty: {current.minLevel === null ? 'N/A' : parseFloat(current.minLevel) || 'N/A'}
//                     </Typography>
//                     <TextField label="Description" required fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '0px 12px', minHeight: '80px' } }} />
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Unit" select required fullWidth size="small" value={current.unit} onChange={handleChange('unit')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} error={!!errors.unit} helperText={errors.unit} >
//                             <option value=""></option>
//                             {unitOptions.map(u => (
//                                 <option key={u} value={u}>
//                                     {u}
//                                 </option>
//                             ))}
//                         </TextField>
//                         <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="PO Qty" required size='small' fullWidth type="number" inputProps={{ min: 1 }} value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <Box display="flex" flexDirection="row" gap={1.5}>
//                         <TextField label="Qty" type="number" size="small" value={current.dispatchQty} inputProps={{ min: 1, max: Math.min(parseFloat(current.qty) || 1, current.minLevel === null ? (parseFloat(productMap.get(current.Id)?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity), step: 1 }}
//                             sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: errors.dispatchQty ? 'red' : undefined }, }}
//                             onChange={handleChange('dispatchQty')}
//                             onBlur={() => {
//                                 const product = productMap.get(current.Id);
//                                 const minLevel =
//                                     current.minLevel === null
//                                         ? (parseFloat(product?.minLevel) || Infinity)
//                                         : parseFloat(current.minLevel) || Infinity;

//                                 const limit = Math.min(parseFloat(current.qty) || 1, minLevel);

//                                 const { isValid, correctedValue } =
//                                     validateDispatchQty(
//                                         current.dispatchQty,
//                                         current.qty,
//                                         current.minLevel,
//                                         product?.minLevel
//                                     );

//                                 if (!isValid) {
//                                     setCurrent(prev => ({ ...prev, dispatchQty: correctedValue }));
//                                     setErrors(prev => ({
//                                         ...prev,
//                                         dispatchQty: `Dispatch Qty must be greater than 0 and up to ${limit}`,
//                                     }));
//                                 } else {
//                                     setErrors(prev => ({ ...prev, dispatchQty: undefined }));
//                                 }
//                             }}
//                             error={!!errors.dispatchQty}
//                             helperText={errors.dispatchQty}
//                         />
//                         <TextField label="Rate" size="small" type="number" value={current.rate} onChange={handleChange('rate')} inputProps={{ min: 0 }} sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                         <TextField label="Disc%" size="small" type="number" value={current.disc} onChange={handleChange('disc')} inputProps={{ min: 0, max: 100 }} sx={{ flex: 1, '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     </Box>
//                     <TextField label="Amount" fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
//                     <TextField label="Remark" fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} />
//                     <Box display="flex" justifyContent="center">
//                         {/* <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={hasInvalidDispatchQty()}>
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button> */}
//                         <Button
//                             variant="outlined"
//                             onClick={addProduct}
//                             sx={{ minWidth: 180 }}
//                             disabled={
//                                 hasInvalidDispatchQty() ||
//                                 mode === 'ref' ||
//                                 (mode === 'edit' && hasAnyPOReference()) ||
//                                 (mode === 'edit' && isFinalLocked)
//                             }
//                         >
//                             {editIndex != null ? 'Update Product' : 'Add Product'}
//                         </Button>

//                     </Box>
//                 </Box>
//                 <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
//                     {isMobile ? (
//                         <Box>
//                             {rows.map((row, i) => (
//                                 <Box
//                                     key={i}
//                                     sx={{
//                                         border: "1px solid #cbd5e1",
//                                         borderRadius: 2,
//                                         p: 1.5,
//                                         mb: 1.5,
//                                         cursor: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref') ? 'not-allowed' : 'pointer',
//                                         color: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref') && "text.disabled",
//                                     }}
//                                 >
//                                     <Typography sx={{ fontWeight: 600 }}>
//                                         {row.productCode} â€” <span style={{ fontStyle: "italic", fontWeight: "normal" }}>
//                                             {row.description}
//                                         </span>
//                                     </Typography>

//                                     {(row.PONumber || row.PODate) && (
//                                         <Typography variant="caption" display="block" color='blue'>
//                                             {row.PONumber && `PONo: ${row.PONumber}`}
//                                             {row.PODate && ` | Date: ${row.PODate}`}
//                                         </Typography>
//                                     )}

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Qty:</Typography>
//                                         <Typography>{row.qty}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Rate:</Typography>
//                                         <Typography>₹{row.rate}</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Disc:</Typography>
//                                         <Typography>{row.disc}%</Typography>
//                                     </Grid>

//                                     <Grid container justifyContent="space-between">
//                                         <Typography>Amount:</Typography>
//                                         <Typography>₹{row.amount}</Typography>
//                                     </Grid>

//                                     {/* DELETE / EDIT BUTTONS IF NEEDED */}
//                                     <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
//                                         <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
//                                             <EditIcon fontSize="small" />
//                                         </IconButton>
//                                         <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
//                                             <DeleteIcon fontSize="small" />
//                                         </IconButton>
//                                     </Box>
//                                 </Box>
//                             ))}
//                         </Box>
//                     ) : (
//                         <DataGrid
//                             rows={rows.map((r, i) => ({ ...r, id: i + 1, index: i }))}
//                             columns={columns}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             disableRowSelectionOnClick
//                             hideFooter
//                             sx={{
//                                 mt: 5,
//                                 border: '1px solid #cbd5e1',
//                                 borderRadius: 1,
//                                 '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
//                                 '& .MuiDataGrid-columnHeader': { backgroundColor: '#f0f0f0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#edf2feff' },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#ffffff' }
//                             }}
//                         />
//                     )}
//                     <Box mt={3}>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Basic Amount</Typography>
//                             <Typography>₹{formatINR(totals.basic)}</Typography>
//                         </Grid>
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Discounted Amount</Typography>
//                             <Typography>₹{formatINR(totals.discount)}</Typography>
//                         </Grid>
//                         {state?.toLowerCase() === compState?.toLowerCase() ? (
//                             <>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>CGST</Typography>
//                                     <Typography>₹{formatINR(totals.cgst)}</Typography>
//                                 </Grid>
//                                 <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                     <Typography>SGST</Typography>
//                                     <Typography>₹{formatINR(totals.sgst)}</Typography>
//                                 </Grid>
//                             </>
//                         ) : (
//                             <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                                 <Typography>IGST</Typography>
//                                 <Typography>₹{formatINR(totals.igst)}</Typography>
//                             </Grid>
//                         )}
//                         <Grid container justifyContent="space-between" alignItems="center" mb={1}>
//                             <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
//                             <Typography>₹{formatINR(totals.roundOff)}</Typography>
//                         </Grid>
//                         <Divider sx={{ my: 1 }} />
//                         <Grid container justifyContent="space-between" alignItems="center">
//                             <Typography fontWeight={600}>Total Amount</Typography>
//                             <Typography fontWeight={600}>₹{formatINR(totals.total)}</Typography>
//                         </Grid>
//                     </Box>
//                 </Box>
//             </Box>
//             {!!errors.global && <Typography color="error" sx={{ mt: 2 }}>{errors.global}</Typography>}
//             <Box mt={1} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={
//                     isEditingMode ||
//                     (mode === 'edit' && isFinalLocked)
//                 }>
//                     Next
//                 </Button>
//             </Box>
//         </Paper>
//     );
// };

// export default ProductDetails;

import { useState, useEffect, useRef, useMemo } from 'react';
import { Box, Paper, Typography, TextField, Button, IconButton, useMediaQuery, useTheme, Grid, Divider, Tooltip, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid } from '@mui/x-data-grid';
import DropdownProductCode from './DropdownProductCode';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../context/AuthContext';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import Dropdown from '../../../components/Dropdown';
import { display } from '@mui/system';
import { useVisibleColumns } from '../../../hooks/useVisibleColumns';
import { COL } from '../../../constants/columnConstants';
import { useUserDefine } from '../../../context/UserDefineContext';
import { useStockValidation } from '../../../hooks/useStockValidation';

// "Apply in Amt = Pkg*Qty*Rate?" — when this configure is enabled, a Pkg field
// containing anything that isn't a clean number (letters/special characters) must
// make the Pkg*Qty*Rate calculation come out as 0, instead of calculateAmount()'s
// own internal `Number(pkg) || 1` silently promoting invalid input back to 1.
// Blank/null/undefined Pkg is untouched — it still defaults to 1 (existing
// behavior for a fresh row before the user has typed a Pkg value).
const isGarbagePkg = (rawPkg) =>
    rawPkg !== '' && rawPkg !== null && rawPkg !== undefined && Number.isNaN(Number(rawPkg));

const getAmountCalcSafe = (qty, rate, rawPkg, disc, isApplyPkgInAmtEnabled, calculateAmount) => {
    if (isApplyPkgInAmtEnabled && isGarbagePkg(rawPkg)) {
        return { gross: 0, taxable: 0 };
    }
    return calculateAmount(qty, rate, rawPkg, disc);
};

const ProductDetails = ({ initialData, onNext, clientData, connectionString, mode, isFinalLocked, onRowsChange, L_No }) => {
    const { user, selectedCompany, loading, configureData } = useAuth();
    const { isColVisible, getColLabel, getColRow } = useVisibleColumns('PCHAL');
    // RupessToBeAsk=1 ("Rupees") -> only the Oth field itself is shown (as before).
    // RupessToBeAsk=0 ("Percentage") -> also show its disabled, read-only Amount field.
    const isOthRupeesMode = (colNo) => Boolean(getColRow(colNo)?.RupessToBeAsk);
    const { getSelectedCharges, getChargeItemId, userDefineData } = useUserDefine();
    const { validateStock, isShowOnlineStockPurchaseEnabled, getOnlineStockDetails, isLastPurchaseRateEnabled, getLastPurchaseRate, isApplyPkgInAmtEnabled, calculateAmount, isShowItemListPartywiseInPurchaseEnabled, isApplyPartywisePriceListDiscInPurchaseEnabled, getPriceListRatePurchase, getClientDiscountPurchase, getGroupWiseDiscPurchase, getPartywiseRatePurchase, isApplyRateOnConversionEnabled, calculateConversion, isApplyMRPInPurchaseEnabled, calculatePurchaseRateFromMRP , isDiscSchemeEnabled, getClientDiscScheme } = useStockValidation(connectionString, selectedCompany?.CompId, selectedCompany?.AppRegID);
    console.log('📊 purchase_Dispatch: isShowOnlineStockPurchaseEnabled:', isShowOnlineStockPurchaseEnabled);
    // getSelectedCharges() returns a brand-new array on every call (Array.filter),
    // even when userDefineData hasn't changed — used as a useEffect dependency
    // further down, an unstable reference there re-fires those effects (and their
    // setState calls) on every render, causing an infinite render loop. Memoize
    // on userDefineData (the actual stable source data) so the array reference
    // only changes when the underlying charges data actually changes.
    const additionalCharges = useMemo(() => getSelectedCharges('PCHAL'), [userDefineData]);

    // Stock validation warning dialog state
    const [stockWarningOpen, setStockWarningOpen] = useState(false);
    const [stockWarningData, setStockWarningData] = useState(null);
    const [stockConfirmResolve, setStockConfirmResolve] = useState(null);
    // "Enable Convesrion effect in Transaction?" — popup shown whenever the row's Unit is
    // changed away from the product's own default Unit. pendingUnitChange holds
    // the in-progress selection (unit name/id) until the user confirms or
    // cancels; previousUnit/previousUnitId let Cancel revert the <select> back
    // to whatever it was before this change (no half-applied Unit change).
    const [conversionQtyDialogOpen, setConversionQtyDialogOpen] = useState(false);
    const [conversionQtyInput, setConversionQtyInput] = useState('');
    const [pendingUnitChange, setPendingUnitChange] = useState(null); // { unit, UnitId, previousUnit, previousUnitId }
    const [onlineStockDetails, setOnlineStockDetails] = useState({
        closingStock: null,
        maxLevel: null,
        minLevel: null,
    });

    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);
    const [chargesCollapsibleOpen, setChargesCollapsibleOpen] = useState(true);
    const [chargeInputs, setChargeInputs] = useState({});
    // Additional Charges contribution applied to the summary panel — populated
    // only when the user clicks Save in the Charges popup (see handleSaveCharges).
    const [chargesSummary, setChargesSummary] = useState({ total: 0, cgst: 0, sgst: 0, igst: 0 });

    // Restore chargeInputs and chargesSummary from initialData if provided (when loading an existing quotation)
    useEffect(() => {
        // API chargeInputs are already keyed by TransType (200, 201, 202, 203, 204)
        // which matches charge.TransType in additionalCharges, so no mapping needed
        if (initialData?.chargeInputs && Object.keys(initialData.chargeInputs).length > 0) {
            console.log('[ChargeInputs Debug] API chargeInputs keys:', Object.keys(initialData.chargeInputs));
            if (additionalCharges && additionalCharges.length > 0) {
                console.log('[ChargeInputs Debug] additionalCharges:', additionalCharges.map(c => ({ TransType: c.TransType, SrNo: c.SrNo, name: c.ChargeName })));
            }
            setChargeInputs(initialData.chargeInputs);
        }

        // Restore chargesSummary from charge rows in tableData (has actual calculated tax amounts)
        // This is more reliable since the API calculates taxes based on actual requirements
        if (initialData?.tableData) {
            const chargesTaxData = { total: 0, cgst: 0, sgst: 0, igst: 0 };

            initialData.tableData.forEach(row => {
                const transType = row.TransType != null ? parseInt(row.TransType) : 100;
                const isCharge = transType >= 200 && transType <= 204;
                if (isCharge) {
                    // Use the amount from the charge row
                    chargesTaxData.total += Number(row.amount || 0);
                    // Add the tax amounts from the charge row (already calculated by backend)
                    chargesTaxData.cgst += Number(row.CGSTAmt || 0);
                    chargesTaxData.sgst += Number(row.SGSTAmt || 0);
                    chargesTaxData.igst += Number(row.IGSTAmt || 0);
                }
            });

            console.log('[ChargesSummary Debug] Calculated from tableData:', chargesTaxData);

            if (chargesTaxData.total > 0 || chargesTaxData.cgst > 0 || chargesTaxData.sgst > 0 || chargesTaxData.igst > 0) {
                setChargesSummary(chargesTaxData);
            }
        }
        // Depend on the specific fields read above, not the whole initialData object —
        // initialData is a fresh object literal from the parent on every render
        // (formData.product || {}), so depending on it directly re-fires this effect
        // (and its setChargesSummary call) on every parent re-render, not just when
        // the actual saved charge data changes.
    }, [initialData?.chargeInputs, initialData?.tableData]);

    // Populate each charge slot's editable state (Amount, and Tax when TaxEnabled)
    // fresh every time the popup opens — default Tax is whatever was saved for
    // that slot in UserDefineColumns (charge.TaxId). Preserve amount if already restored from initialData.
    useEffect(() => {
        if (!chargesDialogOpen) return;
        setChargeInputs(prev => {
            const next = { ...prev };
            additionalCharges.forEach(charge => {
                const key = charge.TransType;
                if (!next[key]) {
                    // Only set empty amount if not already populated (e.g., from initialData restore)
                    next[key] = {
                        amount: '',
                        taxId: charge.TaxId ?? null,
                    };
                } else {
                    // Preserve existing amount, but update taxId to the configured one if not already set
                    if (next[key].taxId === null && charge.TaxId !== null) {
                        next[key].taxId = charge.TaxId;
                    }
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chargesDialogOpen, additionalCharges]);

    const updateChargeInput = (key, patch) => {
        setChargeInputs(prev => ({
            ...prev,
            [key]: { ...prev[key], ...patch },
        }));
    };
    const companyId = selectedCompany?.CompId || null;
    const state = clientData?.details?.['State'];
    const compState = selectedCompany?.State;
    console.log(state, compState);
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [rows, setRows] = useState([]);
    const [nextSrNo, setNextSrNo] = useState(1);
    const [current, setCurrent] = useState({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: mode === 'add' ? '' : null, dispatchQty: null, rate: '', disc: '', tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, TransType: 100, refNo: '', refDate: '', refQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth1Amt: '', oth2: '', oth2Amt: '', oth3: '', oth3Amt: '', UTGST: '0.00', GSTCess: '0.00', GSTOth: '0.00', PONo: '', ProdPODate: '', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth4Amt: '', oth5: '', oth5Amt: '', oth6: '', oth6Amt: '', oth7: '', oth7Amt: '',
        // "Enable Convesrion effect in Transaction?" fields — defaultUnit/defaultUnitId/convUnitId/
        // productConvQty are captured once at product-select time from productmaster
        // (UnitId/ConvUnit/ConvQty) and never change while this row's product stays
        // the same. baseRate preserves the rate as it stood before any conversion
        // division, so switching Unit back to the default can restore it exactly.
        // ConversionQty/ConversionRate are only non-null while a conversion is
        // actively applied to this row (see purcchallandetails.ConversionQty/
        // ConversionRate columns) — both map 1:1 onto payload/stock fields.
        defaultUnit: '', defaultUnitId: '', convUnitId: '', convUnitName: '', productConvQty: '', baseRate: 0, ConversionQty: null, ConversionRate: null, MRP: 0 });
    const [errors, setErrors] = useState({});
    const [editIndex, setEditIndex] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const [productMap, setProductMap] = useState(new Map());
    const [unitOptions, setUnitOptions] = useState([]);
    const [unitMap, setUnitMap] = useState(new Map());
    const [colorMap, setColorMap] = useState({});
    const [sizeMap, setSizeMap] = useState({});
    const [totals, setTotals] = useState({ basic: '0.00', grossBasic: '0.00', discount: '0.00', cgst: '0.00', sgst: '0.00', igst: '0.00', roundOff: '0.00', total: '0.00' });
    const [originalEditQty, setOriginalEditQty] = useState(null);
    const [isEditingMode, setIsEditingMode] = useState(false);

    const [gsts, setGsts] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const [isInitialized, setIsInitialized] = useState(false);

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };


    const API_BASE = `${connectionString}/api`;


    // Track if component has finished initializing
    const hasInitializedRef = useRef(false);

    // When true, the next run of the live-calculation effect is skipped —
    // set right before a row's DB values are loaded into `current` (editRow),
    // so entering edit mode doesn't immediately overwrite the stored amount.
    const skipNextCalcRef = useRef(false);

    // Ref to the Product Code field for auto-focus
    const productCodeRef = useRef(null);

    // Notify parent when rows change â€” but ONLY after initialization is done
    useEffect(() => {
        if (!hasInitializedRef.current) return; // Don't fire on first empty render
        if (onRowsChange) {
            onRowsChange(rows);
        }
    }, [rows]);

    // Reset isInitialized when coming back with data but rows are empty
    useEffect(() => {
        if (initialData?.tableData?.length && rows.length === 0 && hasInitializedRef.current) {
            setIsInitialized(false);
        }
    }, [initialData?.tableData]);

    // For add mode â€” no initialData, so mark as initialized immediately
    useEffect(() => {
        if (!initialData?.tableData?.length) {
            hasInitializedRef.current = true;
        }
    }, []);


    const transformGSTs = data =>
        Array.isArray(data)
            ? data.map(i => ({ Id: i.TaxID, value: i.Taxcode }))
            : [];

    const Hlp_Fn_GST = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}/product-get-data/api/gst?companyId=${companyId}`);
            console.log(data)
            setGsts(transformGSTs(data));
        } catch (e) {
            console.error('GST lookup failed', e);
            setSnackbar({ open: true, message: 'GST lookup failed.', severity: 'error' });
            setGsts([]);
        }
    };

    useEffect(() => {
        Hlp_Fn_GST();
    }, []);
    const rowsRef = useRef([]);
    useEffect(() => {
        rowsRef.current = rows;
    }, [rows]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [unitsRes, cRes, sRes] = await Promise.all([
                    axios.get(`${connectionString}/api/unit/retrive`, { params: { companyId } }),
                    axios.get(`${connectionString}/api/colormaster`),
                    axios.get(`${connectionString}/api/sizemaster`),
                ]);
                const unitsData = unitsRes?.data || [];
                const units = unitsData.map(u => u.unit);
                const unitIdMap = new Map(unitsData.map(u => [u.unit, u.UnitId]));
                setUnitOptions(units);
                setUnitMap(unitIdMap);
                const cm = {}, sm = {};
                cRes.data.forEach(c => (cm[c.colorId] = { name: c.itemColor, code: c.colorCode }));
                sRes.data.forEach(s => (sm[s.sizeId] = { name: s.itemSize, code: s.sizeCode }));
                setColorMap(cm);
                setSizeMap(sm);
            } catch (error) {
                console.error('Error fetching product or unit data:', error);
            }
        };
        fetchData();
        loadAllProducts();
    }, []);

    const handleProductAdded = async () => {
        // Reload units when product is added
        try {
            const unitsRes = await axios.get(`${connectionString}/api/unit/retrive`, {
                params: { companyId }
            });
            setUnitOptions(unitsRes.data);

            // Also reload products
            await loadAllProducts();
        } catch (error) {
            console.error('Error refreshing data:', error);
        }
    };

    const loadAllProducts = async () => {
        try {
            // When "Show Item List Partywise in Purchase?" is enabled, pass partyId so the
            // API joins with partywiserate and returns only items configured for this party.
            const params = { companyId, mode: 'PURC' };
            if (isShowItemListPartywiseInPurchaseEnabled && clientData?.clientId) {
                params.partyId = clientData.clientId;
                params.AppRegID = selectedCompany?.AppRegID;
            }

            const res = await axios.get(`${connectionString}/api/productdata/retrive`, { params });
            setAllProducts(res.data || []);
            setProductMap(new Map(res.data.map(p => [p.Id, p])));
        } catch (e) {
            console.error('Error loading products:', e);
        }
    };

    const getTaxPercent = (value) => {
        if (!value) return 0;

        // remove % sign
        const cleaned = value.replace('%', '').trim();

        const parsed = parseFloat(cleaned);

        return isNaN(parsed) ? 0 : parsed;
    };

    useEffect(() => {
        if (isInitialized || !initialData?.tableData || !Array.isArray(initialData.tableData) || !allProducts.length) {
            if (rowsRef.current.length > 0) {
                setRows(rowsRef.current);
            }
            return;
        }
        console.log("init data:", initialData);

        const isEditMode = initialData.tableData.some(r => r.challanDtsID || r.challanID);
        console.log("Detected Mode:", isEditMode ? "Edit" : "Ref");

        // The products grid (`rows`) must only ever hold normal product rows.
        // Additional Charges (TransType 200-204) and RoundOff (300) are restored
        // separately (chargeInputs / roundOff field) and re-added at submit time —
        // including them here as well would duplicate them in the outgoing payload.
        const regularRows = initialData.tableData.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);

        const initialRows = regularRows.map((r, index) => {
            // Preserve SrNo from database for regular products and charges
            // Regular products: SrNo is sequential (1, 2, 3...)
            // Charges: SrNo is 20000-20004 (already set by backend)
            const srNoValue = r.SrNo != null ? Number(r.SrNo) : (r.srNo != null ? Number(r.srNo) : null);
            let qty, dispatchQty;

            if (mode === 'edit') {
                // For edit mode: use raw values from database directly
                qty = r.qty === null || r.qty === undefined || Number(r.qty) === 0 ? '' : Number(r.qty);
                dispatchQty = r.dispQty !== null && r.dispQty !== undefined ? Number(r.dispQty) : r.dispatchQty !== null && r.dispatchQty !== undefined ? Number(r.dispatchQty) : '';
            } else {
                // For ref/add mode: Backend already calculates remaining qty
                // qty = remaining quantity (originalQty - challanDispatchedQty)
                // dispatchQty = remaining quantity (same as qty, what can be dispatched)
                // Use the values directly from backend - they are already the remaining quantities
                qty = Number(r.qty) || 0;
                dispatchQty = Number(r.dispatchQty) || Number(r.qty) || 0;

                // If qty is 0, it means fully dispatched - this shouldn't happen as backend filters it out
                // But as a safety net, set minimum to 1 only if qty > 0
                if (qty === 0) {
                    console.warn(`Product ${r.productCode} has 0 qty - should have been filtered by backend`);
                }
            }

            const rate = parseFloat(r.rate) || 0;
            const disc = parseFloat(r.disc) || 0;
            // Prefer the exact amount stored in the database over recomputing it —
            // recomputing here can silently diverge from what was actually saved.
            // Only fall back to dispatchQty*rate*(1-disc/100) when the DB has no stored amount.
            const storedAmt = r.amount ?? r.TaxableAmt ?? r.taxableAmount;
            const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
            const amount = hasStoredAmt ? Number(storedAmt) : parseFloat((dispatchQty * rate * (1 - disc / 100)).toFixed(2));

            // const gst = parseFloat(r.GST) || 0;
            // const cgst = parseFloat(r.CGST) || 0;
            // const sgst = parseFloat(r.SGST) || 0;
            // const igst = parseFloat(r.IGST) || 0;
            // const taxPercent = gst || (cgst + sgst) || igst || 0;

            let taxId = r.taxId || r.TaxId || null;
            //  GST lookup
            const matchedGST = gsts.find(g => String(g.Id) === String(taxId));

            //  final %
            const taxPercent = matchedGST
                ? getTaxPercent(matchedGST.value)
                : Number(r.tax) || (Number(r.CGST) + Number(r.SGST)) || Number(r.IGST) || 0;

            // const gst = Number(r.GST) || 0;

            //  split taxes
            const isSameState = state?.toLowerCase() === compState?.toLowerCase();

            const cgst = isSameState ? taxPercent / 2 : 0;
            const sgst = isSameState ? taxPercent / 2 : 0;
            const igst = !isSameState ? taxPercent : 0;


            console.log("taxPercentttt", taxPercent)

            let unitName = '';
            if (r.unit && r.unit.toString().trim()) {
                unitName = r.unit.toString().trim();
            } else if (r.Unit && r.Unit.toString().trim()) {
                unitName = r.Unit.toString().trim();
            } else if (r.UnitId) {
                unitName = Array.from(unitMap.entries()).find(([_, id]) => String(id) === String(r.UnitId))?.[0] || '';
            }

            // "Enable Convesrion effect in Transaction?" — resolve this row's product from
            // allProducts (same as handleSelect) purely to re-derive the UI-only
            // defaultUnit/defaultUnitId/convUnitId/convUnitName/productConvQty
            // fields below; nothing else in this mapping depends on it.
            const product = allProducts.find(p => String(p.Id) === String(r.productId || r.Id || r.id) || p.itemCode === r.productCode);
            const matchedUnit = r.UnitId
                ? unitOptions.find(u => String(u.UnitId) === String(r.UnitId))
                : null;

            const POID = r.POID ?? r.POId ?? r.POID ?? null;
            const PODtsID = r.PODtsID ?? r.PODtsId ?? r.PODtsID ?? null;

            const row = {
                ...r,
                productId: r.productId || r.Id || r.id,
                UnitId: r.UnitId || null,
                unit: unitName,
                qty: qty,
                dispatchQty: dispatchQty,
                rate,
                disc,
                tax: taxPercent,
                TaxId: taxId,
                amount,
                // "Enable Convesrion effect in Transaction?" — re-derive these UI-only fields from
                // the product's CURRENT registered defaults (same as handleSelect),
                // since they're never persisted and a saved row's editRow spread
                // would otherwise leave defaultUnit/defaultUnitId unset, silently
                // disabling the Unit-change conversion prompt in edit mode.
                // baseRate stays the ORIGINAL pre-conversion (Purchase) rate:
                // r.ConversionRate when a conversion was active on this saved row,
                // else the row's own rate. This module keys the Unit-change
                // handler by unit NAME (defaultUnit), so both name and id forms
                // are set, matching handleSelect exactly.
                defaultUnit: matchedUnit ? matchedUnit.unit : (product?.Unit || product?.unit || unitName || ''),
                defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : (product?.UnitId ? String(product.UnitId) : ''),
                convUnitId: product?.ConvUnit ? String(product.ConvUnit) : '',
                convUnitName: product?.ConvUnit
                    ? (unitOptions.find(u => String(u.UnitId) === String(product.ConvUnit))?.unit || '')
                    : '',
                productConvQty: Number(product?.ConvQty) || '',
                baseRate: r.ConversionRate != null ? Number(r.ConversionRate) : rate,
                taxAmount: parseFloat((amount * taxPercent / 100).toFixed(2)),
                taxableAmount: amount,
                minLevel: r.minLevel === null ? null : parseFloat(r.minLevel) || Infinity,
                srNo: srNoValue,
                id: srNoValue,
                GST: `${taxPercent}%`,
                CGST: cgst.toString(),
                SGST: sgst.toString(),
                IGST: igst.toString(),
                POID,
                PODtsID,
                PONo: r.PONo || '',
                ProdPODate: r.ProdPODate || '',
                per: r.per || r.Per || '',
                poQty: r.poQty || r.ProdPOQty || '',
                // Store original values for reference
                originalQty: Number(r.originalQty) || qty,
                challanDispatchedQty: Number(r.challanDispatchedQty) || 0,
                TransType: r.TransType || 100,

            };

            console.log(`Loading row (Mode: ${isEditMode ? 'Edit' : 'Ref'}): qty=${qty}, dispatchQty=${dispatchQty}, POID=${POID}, PODtsID=${PODtsID}, originalQty=${r.originalQty}, challanDispatchedQty=${r.challanDispatchedQty}`);
            return row;
        });

        setRows(initialRows);
        setNextSrNo(initialRows.length + 1);
        setIsInitialized(true);
        hasInitializedRef.current = true; // â† for lifting rows state up 
    }, [initialData?.tableData, unitMap, gsts, isInitialized, allProducts]);

    // Re-load products when party-wise filter config or selected client changes
    // to ensure dropdown always shows the correct filtered list based on current settings
    useEffect(() => {
        loadAllProducts();
    }, [isShowItemListPartywiseInPurchaseEnabled, clientData?.clientId]);

    useEffect(() => {
        setTotals(calculateTotals());
    }, [rows, state, compState, chargesSummary, isApplyPkgInAmtEnabled]);

    // Pkg is folded in only when "Apply in Amt = Pkg*Qty*Rate?" is enabled — see
    // calculateAmount in useStockValidation.js. pkg defaults to 1 when empty/0.
    const calcAmount = ({ dispatchQty, rate, disc, pkg }) => getAmountCalcSafe(dispatchQty, rate, pkg, disc, isApplyPkgInAmtEnabled, calculateAmount).taxable;
    const calcTaxAmount = ({ dispatchQty, rate, disc, tax, pkg }) => parseFloat((calcAmount({ dispatchQty, rate, disc, pkg }) * (tax / 100)).toFixed(2));

    // Prefer each row's own stored amount over recomputing it from today's live
    // Pkg-flag setting — that flag may have changed since the row was saved
    // (see calcAmount above). Only recalculate when the row truly has no
    // stored amount (e.g. a brand-new row not yet saved).
    const effectiveRowAmount = r => {
        const storedAmt = r.amount ?? r.TaxableAmt ?? r.taxableAmount;
        const hasStoredAmt = storedAmt != null && storedAmt !== '' && !Number.isNaN(Number(storedAmt));
        return hasStoredAmt ? Number(storedAmt) : calcAmount(r);
    };

    const calculateTotals = () => {
        const regularRows = rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300);
        const basic = regularRows.reduce((sum, r) => sum + effectiveRowAmount(r), 0);
        const grossAmountSum = regularRows.reduce((sum, r) => sum + getAmountCalcSafe(Number(r.dispatchQty) || 0, Number(r.rate) || 0, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross, 0);
        const discount = regularRows.reduce((sum, r) => sum + (getAmountCalcSafe(Number(r.dispatchQty) || 0, Number(r.rate) || 0, r.pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross * (r.disc / 100)), 0);
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        const cgstTotal = isSameState ? regularRows.reduce((sum, r) => sum + (parseFloat(r.CGST) * effectiveRowAmount(r) / 100), 0) : 0;
        const sgstTotal = isSameState ? regularRows.reduce((sum, r) => sum + (parseFloat(r.SGST) * effectiveRowAmount(r) / 100), 0) : 0;
        const igstTotal = isSameState ? 0 : regularRows.reduce((sum, r) => sum + (parseFloat(r.IGST) * effectiveRowAmount(r) / 100), 0);
        const taxableTotal = basic + cgstTotal + sgstTotal + igstTotal;
        // Additional Charges must be folded in before rounding, so Round Off reflects them
        const chargesTotal = Number(chargesSummary.total || 0)
            + Number(chargesSummary.cgst || 0)
            + Number(chargesSummary.sgst || 0)
            + Number(chargesSummary.igst || 0);
        const finalAmount = taxableTotal + chargesTotal;
        // const roundedFinal = Math.ceil(finalAmount);
        // const roundOff = roundedFinal - finalAmount;
        const decimalPart = finalAmount - Math.floor(finalAmount);
        const roundedFinal = decimalPart >= 0.5 ? Math.ceil(finalAmount) : Math.floor(finalAmount);
        const roundOff = Number((roundedFinal - finalAmount).toFixed(2));
        console.log("taxable:", taxableTotal);

        return {
            basic: basic.toFixed(2),
            grossBasic: grossAmountSum.toFixed(2),
            discount: discount.toFixed(2),
            cgst: cgstTotal.toFixed(2),
            sgst: sgstTotal.toFixed(2),
            igst: igstTotal.toFixed(2),
            roundOff: roundOff.toFixed(2),
            total: roundedFinal.toFixed(2),
        };
    };

    // Additional Charges: given a charge and its current popup input, compute
    // the charge amount, the tax on it (only when TaxEnabled), and the final
    // (tax-inclusive) amount — this is what "Final Amount" displays live.
    const getChargeFinalAmounts = (charge, input) => {
        const chargeAmount = Number(input?.amount) || 0;
        if (!charge.TaxEnabled) {
            return { chargeAmount, taxPercent: 0, taxAmount: 0, finalAmount: chargeAmount };
        }
        const selectedGST = gsts.find(g => String(g.Id) === String(input?.taxId));
        const taxPercent = parseFloat(selectedGST?.value) || 0;
        const taxAmount = chargeAmount * taxPercent / 100;
        return { chargeAmount, taxPercent, taxAmount, finalAmount: chargeAmount + taxAmount };
    };

    // Additional Charges: on Save, fold every charge's final amount into the
    // Total Amount shown in the summary, and its tax (if any) into CGST+SGST
    // (same state) or IGST (different state) — same split rule calculateTotals
    // already uses for product rows.
    const handleSaveCharges = () => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
        setChargesDialogOpen(false);
    };

    // ✅ Auto-sync chargesSummary with chargeInputs whenever charges are entered
    // This ensures charges are calculated in real-time without needing a Save button
    useEffect(() => {
        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        let addTotal = 0, addCgst = 0, addSgst = 0, addIgst = 0;
        additionalCharges.forEach(charge => {
            const key = charge.TransType;
            const input = chargeInputs[key];
            if (!input || !input.amount) return;
            const amount = Number(input.amount) || 0;
            const { taxAmount } = getChargeFinalAmounts(charge, input);
            addTotal += amount;
            if (charge.TaxEnabled) {
                if (isSameState) {
                    addCgst += taxAmount / 2;
                    addSgst += taxAmount / 2;
                } else {
                    addIgst += taxAmount;
                }
            }
        });
        setChargesSummary({ total: addTotal, cgst: addCgst, sgst: addSgst, igst: addIgst });
    }, [chargeInputs, additionalCharges, state, compState, gsts]);

    const colorOptions = Object.entries(colorMap).map(([id, v]) => ({ id: +id, ...v }));
    const sizeOptions = Object.entries(sizeMap).map(([id, v]) => ({ id: +id, ...v }));

    useEffect(() => {
        // `current` was just loaded from a saved row (editRow) — skip this one
        // pass so the DB-stored amount isn't immediately overwritten before the
        // user has actually changed anything.
        if (skipNextCalcRef.current) {
            skipNextCalcRef.current = false;
            return;
        }

        const dispatchQty = parseFloat(current.dispatchQty) || 0;
        const rate = parseFloat(current.rate) || 0;
        const disc = parseFloat(current.disc) || 0;
        const amount = calcAmount({ dispatchQty, rate, disc, pkg: current.pkg });
        setCurrent(prev => ({ ...prev, amount: amount.toFixed(2) }));
    }, [current.dispatchQty, current.rate, current.disc, current.pkg, isApplyPkgInAmtEnabled]);

    // Fetch online stock details when current product changes (for purchase)
    useEffect(() => {
        const fetchOnlineStock = async () => {
            if (isShowOnlineStockPurchaseEnabled && current.Id) {
                console.log('📊 purchase_Dispatch: Fetching online stock details for product:', current.Id);
                const details = await getOnlineStockDetails(current.Id);
                console.log('📊 purchase_Dispatch: Online stock details:', details);
                setOnlineStockDetails({
                    closingStock: details.closingStock,
                    maxLevel: details.maxLevel,
                    minLevel: details.minLevel,
                });
            }
        };
        fetchOnlineStock();
    }, [current.Id, isShowOnlineStockPurchaseEnabled, getOnlineStockDetails]);

    // const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null) => {
    //     const parsedDispatchQty = parseFloat(dispatchQty) || 0;
    //     const parsedQty = parseFloat(qty) || 0;
    //     let parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? parseFloat(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? parseFloat(productMinLevel) : Infinity;
    //     const minQty = 1;
    //     const limit = Math.min(parsedQty, parsedMinLevel);
    //     const isValid = Number.isFinite(parsedDispatchQty) && parsedDispatchQty >= minQty && parsedDispatchQty <= limit;
    //     return { isValid, correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit)) };
    // };

    // âœ… FIX 2: validateDispatchQty
    // Rules:
    //   add mode   â†’ no SO/PO qty upper-bound at all; only minLevel caps it
    //   ref mode   â†’ dispatchQty â‰¤ remaining SO qty AND â‰¤ minLevel
    //   edit mode  â†’ if the row came from a PO/SO reference, dispatchQty â‰¤ stored qty AND â‰¤ minLevel
    //                if the row has no PO reference (free row), same as add mode â€” only minLevel caps it
    // const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null, hasPORef = false) => {
    //     const parsedDispatchQty = Number(dispatchQty) || 0;
    //     const parsedQty = Number(qty) || 0;

    //     const parsedMinLevel =
    //         rowMinLevel != null && !isNaN(rowMinLevel)
    //             ? Number(rowMinLevel)
    //             : productMinLevel != null && !isNaN(productMinLevel)
    //                 ? Number(productMinLevel)
    //                 : Infinity;

    //     const minQty = 1;

    //     let limit;
    //     if (mode === 'add') {
    //         // No SO/PO involved â€” only stock minLevel matters
    //         limit = parsedMinLevel;
    //     } else if (mode === 'ref') {
    //         // Must not exceed the remaining SO qty
    //         limit = Math.min(parsedQty > 0 ? parsedQty : Infinity, parsedMinLevel);
    //     } else {
    //         // edit mode
    //         if (hasPORef && parsedQty > 0) {
    //             // Row is tied to a PO â€” cannot exceed the originally dispatched/linked qty
    //             limit = Math.min(parsedQty, parsedMinLevel);
    //         } else {
    //             // Free row in edit mode â€” same rules as add mode
    //             limit = parsedMinLevel;
    //         }
    //     }

    //     const isValid =
    //         Number.isFinite(parsedDispatchQty) &&
    //         parsedDispatchQty >= minQty &&
    //         parsedDispatchQty <= limit;

    //     return {
    //         isValid,
    //         correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, isFinite(limit) ? limit : parsedDispatchQty)),
    //     };
    // };

    const validateDispatchQty = (dispatchQty, qty, rowMinLevel, productMinLevel = null, hasPORef = false) => {
        const parsedDispatchQty = Number(dispatchQty) || 0;
        const parsedQty = Number(qty) || 0;
        const parsedMinLevel = rowMinLevel != null && !isNaN(rowMinLevel) ? Number(rowMinLevel) : productMinLevel != null && !isNaN(productMinLevel) ? Number(productMinLevel) : Infinity;
        let minQty = null;
        let limit;
        // âœ… EXACT SAME AS SO LOGIC
        if (mode === 'add') {
            limit = parsedMinLevel;
        }
        else if (mode === 'ref') {
            limit = Math.min(parsedQty, parsedMinLevel);
        }
        else if (mode === 'edit') {
            if (hasPORef) {
                limit = Math.min(parsedQty, parsedMinLevel);
            } else {
                limit = parsedMinLevel;
            }
        }
        const isValid = Number.isFinite(parsedDispatchQty) && parsedDispatchQty >= minQty && parsedDispatchQty <= limit;
        return { isValid, correctedValue: Math.max(minQty, Math.min(parsedDispatchQty, limit)) };
    };

    const hasInvalidDispatchQty = () => {
        const rowInvalid = rows.some(row => {

            const hasPORef = rowHasPOReference(row);

            // âœ… EDIT MODE WITHOUT PO â†’ skip validation
            if (mode === 'edit' && !hasPORef) {
                return false;
            }
            const product = productMap.get(row.productId);
            const { isValid } = validateDispatchQty(row.dispatchQty, row.qty, row.minLevel, product?.minLevel, hasPORef);
            return !isValid;
        });

        const currentHasPORef = rowHasPOReference(current);

        const currentInvalid = (mode === 'edit' && !currentHasPORef) ? false : current.dispatchQty && !validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, productMap.get(current.Id)?.minLevel, currentHasPORef).isValid;
        return rowInvalid || currentInvalid;
    };

    // const handleChange = field => e => {
    //     const value = e.target.value;
    //     setCurrent(prev => ({ ...prev, [field]: value }));
    //     if (field === 'dispatchQty') {
    //         const product = productMap.get(current.Id);
    //         const { isValid } = validateDispatchQty(value, current.qty, current.minLevel, product?.minLevel);
    //         setErrors(prev => ({ ...prev, dispatchQty: isValid ? undefined : `Dispatch Qty must be an integer between 1 and ${Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)}` }));
    //     } else if (field === 'unit') {
    //         setCurrent(prev => ({ ...prev, UnitId: unitMap.get(value) || null }));
    //     }
    // };

    const handleChange = field => e => {
        let value = e.target.value;

        // =========================
        // âœ… QTY (LOCK IN EDIT)
        // =========================
        if (field === 'qty') {
            let numeric = parseFloat(value) || 0;

            if (editIndex != null && originalEditQty != null) {
                if (numeric > originalEditQty) {
                    numeric = originalEditQty;
                }
            }

            setCurrent(prev => ({ ...prev, qty: numeric }));
            return;
        }

        // =========================
        // âœ… DISPATCH QTY (SMOOTH INPUT)
        // =========================
        if (field === 'dispatchQty') {

            const product = productMap.get(current.Id);

            const poQty = Number(current.qty) || '';

            const minLevel = current.minLevel === null ? (Number(product?.minLevel) || Infinity) : Number(current.minLevel) || Infinity;
            const limit = mode === 'add' ? minLevel : Math.min(poQty, minLevel);

            // âœ… allow empty typing
            if (value === "") {
                setCurrent(prev => {
                    const updated = { ...prev, dispatchQty: "" };
                    return { ...updated, ...recomputeTaxable(updated) };
                });
                return;
            }

            const numeric = Number(value);

            // âœ… allow typing freely
            if (!Number.isNaN(numeric)) {
                setCurrent(prev => {
                    const updated = { ...prev, dispatchQty: numeric };
                    return { ...updated, ...recomputeTaxable(updated) };
                });
            }

            return;
        }

        // =========================
        // âœ… RATE (EMPTY SUPPORT)
        // =========================
        if (field === 'rate') {

            if (value === "") {
                setCurrent(prev => {
                    const updated = { ...prev, rate: "" };
                    return { ...updated, ...recomputeTaxable(updated) };
                });
                return;
            }

            const numeric = Number(value);

            if (!Number.isNaN(numeric)) {
                setCurrent(prev => {
                    const updated = { ...prev, rate: numeric };
                    return { ...updated, ...recomputeTaxable(updated) };
                });
            }

            return;
        }

        // =========================
        // âœ… PKG (LIVE RECOMPUTE)
        // =========================
        if (field === 'pkg') {
            setCurrent(prev => {
                const updated = { ...prev, pkg: value };
                return { ...updated, ...recomputeTaxable(updated) };
            });
            return;
        }

        // =========================
        // âœ… DISCOUNT (EMPTY SUPPORT)
        // =========================
        if (field === 'disc') {
            if (value === "") {
                setCurrent(prev => ({ ...prev, disc: "" }));
                return;
            }
            const numeric = Number(value);
            if (!Number.isNaN(numeric)) {
                setCurrent(prev => ({ ...prev, disc: numeric }));
            }
            return;
        }

        // =========================
        // âœ… UNIT MAPPING
        // =========================
        if (field === 'unit') {
            const newUnitId = unitMap.get(value) || null;

            // "Enable Convesrion effect in Transaction?" — only intervene when the config is on
            // and the newly-picked unit differs from this product's own default
            // Unit (current.defaultUnit, captured at select time). Changing back
            // to the default reverts immediately with no popup (see below).
            if (isApplyRateOnConversionEnabled && current.defaultUnit && String(value) !== String(current.defaultUnit)) {
                setPendingUnitChange({
                    unit: value,
                    UnitId: newUnitId,
                    previousUnit: current.unit,
                    previousUnitId: current.UnitId,
                });
                // Pre-fill per spec: the product's registered ConvQty only when the
                // newly-picked unit matches the product's registered ConvUnit;
                // otherwise default to 1 (no known ratio for an unrelated unit).
                const matchesConvUnit =
                    (current.convUnitId && String(newUnitId) === String(current.convUnitId)) ||
                    (current.convUnitName && String(value).toLowerCase() === String(current.convUnitName).toLowerCase());
                setConversionQtyInput(matchesConvUnit && current.productConvQty ? String(current.productConvQty) : '1');
                setConversionQtyDialogOpen(true);
                return;
            }

            // Reverting to the product's own default Unit (or config is off) —
            // behave exactly as before, and clear any previously-active conversion.
            setCurrent(prev => ({
                ...prev,
                unit: value,
                UnitId: newUnitId,
                ConversionQty: null,
                ConversionRate: null,
                rate: prev.defaultUnit && String(value) === String(prev.defaultUnit) && prev.baseRate !== '' && prev.baseRate != null
                    ? prev.baseRate
                    : prev.rate,
            }));
            return;
        }

        // =========================
        // âœ… DEFAULT FIELDS
        // =========================
        setCurrent(prev => ({ ...prev, [field]: value }));
    };

    // Oth1→Oth7: each one's amount is applied in order on top of the running
    // TaxableAmt (calcAmount's dispatchQty*rate*(1-disc/100)-equivalent base) —
    // Percentage mode takes its % against the running total so far (not the
    // original base), Rupees mode adds/subtracts a flat value; AddLess=1 means
    // subtract, 0 means add.
    const OTH_FIELDS = [
        { field: 'oth1', col: COL.OTH1 },
        { field: 'oth2', col: COL.OTH2 },
        { field: 'oth3', col: COL.OTH3 },
        { field: 'oth4', col: COL.OTH4 },
        { field: 'oth5', col: COL.OTH5 },
        { field: 'oth6', col: COL.OTH6 },
        { field: 'oth7', col: COL.OTH7 },
    ];
    // Applies Oth1→Oth7 in order on top of `base`, returning both the final
    // taxable amount AND each Oth's own computed rupee contribution (so the
    // disabled "Oth N Amount" field — oth{N}Amt — has something to show in
    // Percentage mode). Used both for the live preview while editing and for
    // the actual Add/Update Product commit and final submit, so none of them disagree.
    // Rupees mode: OthN itself stays 0 in the DB (decimal(5,2), not meant to
    // hold a rupee amount), so the field the user actually types/sees is
    // OthNAmt directly. Percentage mode: the user types the % into OthN, and
    // OthNAmt is the computed, read-only result.
    const othDisplayField = (field, col) => isOthRupeesMode(col) ? `${field}Amt` : field;
    const applyOthCharges = (base, rowState) => {
        let running = base;
        const amounts = {};
        OTH_FIELDS.forEach(({ field, col }) => {
            const amtField = `${field}Amt`;
            const row = getColRow(col);
            const isRupees = Boolean(row?.RupessToBeAsk);
            const isMinus = Boolean(row?.AddLess);
            const raw = isRupees ? rowState[amtField] : rowState[field];
            const val = Number(raw);
            if (!raw || Number.isNaN(val) || val === 0) {
                amounts[amtField] = null;
                return;
            }
            const contribution = isRupees ? val : (running * val) / 100;
            // Rupees mode: amtField IS the field the user is actively typing into
            // (othDisplayField routes it there) — reformatting it with toFixed(2)
            // on every keystroke changes the string under the cursor and resets
            // cursor position to the end. Keep the raw typed text as-is; it's only
            // ever Number()'d downstream, so the unformatted string is fine.
            // Percentage mode's amtField is a separate disabled/read-only display,
            // so reformatting it is safe and keeps it looking like a computed amount.
            amounts[amtField] = isRupees ? raw : contribution.toFixed(2);
            running = isMinus ? running - contribution : running + contribution;
        });
        return { taxableAmt: running, amounts };
    };
    // Recomputes base + Oth1→Oth7 from whatever's currently in `updated`,
    // returning the fields to merge back into state. Shared by the Oth field
    // handler and the Qty/Rate/Disc handlers so TaxableAmt/amount stay
    // Oth-adjusted live, no matter which of the four fields just changed.
    const recomputeTaxable = (updated) => {
        const base = calcAmount({ dispatchQty: updated.dispatchQty, rate: updated.rate, disc: updated.disc, pkg: updated.pkg });
        const { taxableAmt, amounts } = applyOthCharges(base, updated);
        return { ...amounts, TaxableAmt: taxableAmt.toFixed(2), amount: taxableAmt.toFixed(2) };
    };
    const handleOthChange = (field, col) => (e) => {
        let raw = e.target.value;
        // Numbers only (digits with at most one decimal point) — no letters/special chars
        if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) return;
        if (!isOthRupeesMode(col) && raw !== '') {
            // Percentage mode: clamp to [0, 100]
            const num = Number(raw);
            if (num > 100) raw = '100';
            if (num < 0) raw = '0';
        }
        const targetKey = othDisplayField(field, col);
        setCurrent(prev => {
            const updated = { ...prev, [targetKey]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };
    // Qty/Rate/Disc changing also shifts the base amount Oth1-7 are computed
    // from — reapply them live here too, instead of only on Add/Update Product.
    const handleBaseFieldChange = (field) => (e) => {
        const raw = e.target.value;
        setCurrent(prev => {
            const updated = { ...prev, [field]: raw };
            return { ...updated, ...recomputeTaxable(updated) };
        });
    };

    // "Enable Convesrion effect in Transaction?" — Confirm applies the pending Unit change plus
    // the Conversion Qty the user entered/accepted, deriving the billed Rate from
    // this row's baseRate (the rate as it stood before any conversion — captured
    // once at product-select time and preserved untouched so it can always be
    // recovered). Cancel reverts the Unit selection back to whatever it was
    // before, so a cancelled popup never leaves the row half-changed.
    const handleConfirmConversionQty = () => {
        if (!pendingUnitChange) return;
        const convQty = Number(conversionQtyInput) || 0;

        if (convQty > 0) {
            const { rate: convertedRate } = calculateConversion(current.baseRate, current.dispatchQty, convQty);
            setCurrent(prev => ({
                ...prev,
                unit: pendingUnitChange.unit,
                UnitId: pendingUnitChange.UnitId,
                rate: convertedRate,
                ConversionQty: convQty,
                ConversionRate: prev.baseRate,
            }));
        } else {
            // Invalid/blank conversion qty — treat like Cancel rather than divide by zero.
            setCurrent(prev => ({
                ...prev,
                unit: pendingUnitChange.previousUnit,
                UnitId: pendingUnitChange.previousUnitId,
            }));
        }

        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleCancelConversionQty = () => {
        if (pendingUnitChange) {
            setCurrent(prev => ({
                ...prev,
                unit: pendingUnitChange.previousUnit,
                UnitId: pendingUnitChange.previousUnitId,
            }));
        }
        setConversionQtyDialogOpen(false);
        setPendingUnitChange(null);
        setConversionQtyInput('');
    };

    const handleSelect = async product => {

        if (mode === 'edit' && hasAnyPOReference()) {
            setErrors({ global: 'Cannot add products because PO is already linked.' });
            return;
        }
        const matchedUnit = unitOptions.find(opt => {
            if (product.UnitId && String(opt.UnitId) === String(product.UnitId)) return true;
            if (product.Unit && opt.unit?.toLowerCase() === String(product.Unit).toLowerCase()) return true;
            if (product.unit && opt.unit?.toLowerCase() === String(product.unit).toLowerCase()) return true;
            return false;
        });
        const matchedColor = colorOptions.find(opt => opt.name.toLowerCase() === (product.color || '').toLowerCase());
        const matchedSize = sizeOptions.find(opt => opt.name.toLowerCase() === (product.size || '').toLowerCase());
        const tax = parseFloat(product.GST) || 0;
        const taxId = product.TaxId || null;

        // Initialize rate and disc with product defaults
        let rate = Number(product.Rate) === 0 ? '' : Number(product.Rate);
        let disc = Number(product.Discount) === 0 ? '' : Number(product.Discount);
        let MRP = Number(product.MRP) || 0;

        // If "Apply MRP in Purchase?" is enabled and product has MRP, calculate rate from MRP
        if (isApplyMRPInPurchaseEnabled && MRP > 0) {
            console.log('🏷️ purchase_Dispatch: Apply MRP in Purchase enabled. Calculating rate from MRP:', MRP);
            rate = calculatePurchaseRateFromMRP(MRP, tax);
        }

        // "Show Item List Partywise in Purchase?" — when enabled, this item's
        // Rate/Disc must come strictly from partywiserate for this party, with
        // NO fallback to productmaster's purchaseRate/PurcDisc.
        if (isShowItemListPartywiseInPurchaseEnabled && clientData?.clientId) {
            const partywiseData = await getPartywiseRatePurchase(product.Id, clientData.clientId);
            if (partywiseData.found) {
                rate = partywiseData.purchaseRate !== null ? partywiseData.purchaseRate : '';
                disc = partywiseData.disc !== null ? partywiseData.disc : '';
                console.log('✅ purchase_Dispatch: Rate/Disc taken from partywiserate (no productmaster fallback):', rate, disc);
            }
        }

        // Fetch Last Purchase Rate if enabled
        if (isLastPurchaseRateEnabled) {
            console.log('💾 purchase_Dispatch: Fetching last purchase rate for product:', product.Id, 'party:', clientData?.clientId);
            const lastPurchaseData = await getLastPurchaseRate(product.Id, clientData?.clientId);
            if (lastPurchaseData.rate !== null) {
                rate = lastPurchaseData.rate;
                console.log('✅ purchase_Dispatch: Last purchase rate fetched:', rate);
            }
            if (lastPurchaseData.disc !== null) {
                disc = lastPurchaseData.disc;
                console.log('✅ purchase_Dispatch: Last purchase disc fetched:', disc);
            }
        }

        // "Apply Partywise/Price-listwise Disc. in Purchase?" — if the item has a
        // price-list entry, use its NewPrice as the Rate; otherwise the existing
        // productmaster-based rate above is left untouched.
        if (isApplyPartywisePriceListDiscInPurchaseEnabled) {
            const priceListData = await getPriceListRatePurchase(product.Id);
            if (priceListData.found && priceListData.newPrice !== null) {
                rate = priceListData.newPrice;
                console.log('✅ purchase_Dispatch: Rate taken from pricelistdetails:', rate);
            }

            // Disc now comes from groupwisedisc (matched by this item's ItemGrpId for
            // this party), not clientmaster. If there's no matching group-wise entry,
            // Disc is 0.00 — no fallback to clientmaster or productmaster.
            if (clientData?.clientId) {
                const groupDiscData = await getGroupWiseDiscPurchase(product.Id, clientData.clientId);
                disc = groupDiscData.found && groupDiscData.disc !== null ? groupDiscData.disc : 0;
                console.log('✅ purchase_Dispatch: Disc taken from groupwisedisc (no fallback):', disc);
            }
        }

        // "Disc Scheme" — Disc is taken from clientmaster.Disc; Oth1/Oth2 from clientmaster.Disc1/Disc2.
        // Oth1 and Oth2 are checked independently: each is filled only if it is
        // enabled, Percentage (not Rupees) and minus (AddLess). Empty/null -> 0.
        let discSchemeOth = null;
        if (isDiscSchemeEnabled && clientData?.clientId) {
            const scheme = await getClientDiscScheme(clientData.clientId);
            disc = scheme.disc || 0;
            const oth1Qualifies = isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && Boolean(getColRow(COL.OTH1)?.AddLess);
            const oth2Qualifies = isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && Boolean(getColRow(COL.OTH2)?.AddLess);
            if (oth1Qualifies || oth2Qualifies) {
                discSchemeOth = {
                    oth1: oth1Qualifies ? String(scheme.disc1 || 0) : '',
                    oth2: oth2Qualifies ? String(scheme.disc2 || 0) : '',
                };
            }
        }

        setCurrent({
            Id: product.Id.toString(), tax,
            TaxId: taxId, productCode: product.itemCode, description: product.description, UnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId || ''), unit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''), qty: mode === 'add' ? '' : null, dispatchQty: '', rate: rate, disc: disc, tax: parseFloat(product.GST) || 0, MRP, size: matchedSize?.name || '', color: matchedColor?.name || '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: parseFloat(product.minLevel) || null,
            refNo: '', refDate: '', refQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: discSchemeOth ? discSchemeOth.oth1 : '', oth1Amt: null, oth2: discSchemeOth ? discSchemeOth.oth2 : '', oth2Amt: null, oth3: '', oth3Amt: null, oth4: '', oth4Amt: null, oth5: '', oth5Amt: null, oth6: '', oth6Amt: null, oth7: '', oth7Amt: null, UTGST: '0.00', GSTCess: '0.00', GSTOth: '0.00',
            // "Enable Convesrion effect in Transaction?" — captured from productmaster at select
            // time; no conversion is active yet on a freshly-selected row.
            // The Unit <select> is keyed by unit NAME in this module, so the
            // default/conversion units are tracked by name as well as by id.
            defaultUnit: matchedUnit ? matchedUnit.unit : (product.Unit || product.unit || ''),
            defaultUnitId: matchedUnit ? String(matchedUnit.UnitId) : (product.UnitId ? String(product.UnitId) : ''),
            convUnitId: product.ConvUnit ? String(product.ConvUnit) : '',
            convUnitName: product.ConvUnit
                ? (unitOptions.find(u => String(u.UnitId) === String(product.ConvUnit))?.unit || '')
                : '',
            productConvQty: Number(product.ConvQty) || '',
            baseRate: rate,
            ConversionQty: null,
            ConversionRate: null,
        });
        // setEditIndex(null);
        setErrors({});
    };

    const addProduct = async () => {
        const errs = {};
        const messages = new Set();
        const requiredFields = ['productCode', 'description', 'unit', 'dispatchQty', 'tax'];

        let missingRequired = false;
        requiredFields.forEach(field => {
            if (!current[field] && current[field] !== 0) {
                errs[field] = 'Required';
                missingRequired = true;
            }
        });

        if (missingRequired) {
            messages.add('All fields are required.');
        }

        // qty must be > 0 only when a PO is linked (ref/edit-with-PO)
        // In add mode or free edit rows, qty=0 is fine (dispatch qty is the only thing that matters)
        const currentHasPORef = !!(current.POID || current.PODtsID);
        if (currentHasPORef && (!current.qty || parseFloat(current.qty) <= 0)) {
            errs.qty = 'Must be > 0';
            messages.add('Qty must be greater than 0');
        }

        if (Number(current.dispatchQty) <= 0) {
            errs.dispatchQty = 'Must be > 0';
            messages.add('Dispatch Qty must be greater than 0');
        }

        if (current.rate !== '' && Number(current.rate) < 0) {
            errs.rate = 'Rate cannot be negative';
            messages.add('Rate cannot be negative');
        }

        if (current.disc < 0 || current.disc > 100) {
            errs.disc = 'Must be between 0 and 100';
            messages.add('Discount must be between 0 and 100');
        }

        if (current.tax < 0) {
            errs.tax = 'Cannot be negative';
            messages.add('Tax cannot be negative');
        }

          //GST validation
          if (!current.TaxId) {
            errs.TaxId = true;
            messages.add('Please select GST before adding product.');
        }

        const product = productMap.get(current.Id);
        const hasPORef = !!(current.POID || current.PODtsID);
        const { isValid, correctedValue } = validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, product?.minLevel, hasPORef);
        if (!isValid) {
            const limitForMsg = hasPORef
                ? Math.min(parseFloat(current.qty), current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity)
                : (current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity);
            errs.dispatchQty = `Dispatch Qty must be an integer between 1 and ${isFinite(limitForMsg) ? limitForMsg : 'âˆž'}`;
            messages.add(errs.dispatchQty);
        }

        if (messages.size > 0) {
            errs.global = Array.from(messages);
            setErrors(errs);
            return;
        }

        // Stock validation check
        const dispatchQty = Number(current.dispatchQty) || 0;
        const lNo = L_No || null;
        console.log('ProductDetails: Calling validateStock with itemId:', current.Id, 'qty:', dispatchQty, 'L_No:', lNo);
        const stockValidation = await validateStock(current.Id, dispatchQty, lNo);
        console.log('ProductDetails: Stock validation result:', stockValidation);

        if (stockValidation.shouldShowWarning) {
            console.log('ProductDetails: Showing warning dialog');
            const confirmed = await new Promise((resolve) => {
                setStockWarningData(stockValidation);
                setStockConfirmResolve(() => resolve);
                setStockWarningOpen(true);
            });
            if (!confirmed) {
                console.log('ProductDetails: User cancelled, not adding product');
                return;
            }
        } else {
            console.log('ProductDetails: No warning needed, proceeding with add');
        }

        const safeDisc =
            current.disc === '' || current.disc == null
                ? 0
                : Number(current.disc);

        const safeRate =
            current.rate === '' || current.rate == null
                ? 0
                : Number(current.rate);

        const isSameState = state?.toLowerCase() === compState?.toLowerCase();
        const safePkg = Number(current.pkg ?? 1) || 1;
        const baseAmount = calcAmount({ dispatchQty: current.dispatchQty, rate: current.rate, disc: current.disc, pkg: current.pkg });
        // Oth1→Oth7 are applied on top of this base TaxableAmt before the row is committed,
        // so Add/Update Product always carries the Oth-adjusted amount, not the raw base.
        const { taxableAmt: amount, amounts: othAmounts } = applyOthCharges(baseAmount, current);
        const taxAmount = parseFloat((amount * (parseFloat(current.tax || 0) / 100)).toFixed(2));
        const gross = getAmountCalcSafe(current.dispatchQty, safeRate, safePkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
        const discAmt = Number((gross * (safeDisc / 100)).toFixed(2));

        const row = {
            ...current,
            ...othAmounts,
            productId: current.Id,
            UnitId: current.UnitId,
            qty: Number(current.qty) || '',
            rate: safeRate,
            disc: safeDisc,
            DiscAmt: discAmt,
            tax: parseFloat(current.tax) || 0,
            remark: current.remark || '',
            GST: `${current.tax}%`,
            CGST: isSameState ? (current.tax / 2).toString() : '0',
            SGST: isSameState ? (current.tax / 2).toString() : '0',
            IGST: isSameState ? '0' : current.tax.toString(),
            UTGST: current.UTGST || '0',
            GSTCess: current.GSTCess || '0',
            saleRate: current.saleRate || '0',
            saleDiscount: current.saleDiscount || '0',
            amount,
            taxAmount,
            taxableAmount: amount,
            POID: current.POID ?? null,
            PODtsID: current.PODtsID ?? null,
            TransType: current.TransType || 100,
            // "Enable Convesrion effect in Transaction?" — carry the confirmed ratio and the
            // original (pre-division) base rate onto the saved row explicitly, so
            // they survive into `rows` -> payload -> purcchallandetails/stockinout.
            // null on a normal, non-converted row.
            ConversionQty: current.ConversionQty != null ? Number(current.ConversionQty) : null,
            ConversionRate: current.ConversionRate != null ? Number(current.ConversionRate) : null,
        };

        console.log(row);

        const existingRowIndex = rows.findIndex(r => r.productCode === current.productCode);

        // if (existingRowIndex !== -1 && editIndex == null) {
        //     setRows(prev => prev.map((r, i) => {
        //         if (i === existingRowIndex) {
        //             const mergedQty = parseFloat(r.qty) + parseFloat(current.qty);
        //             const mergedDispatchQty = parseFloat(r.dispatchQty) + parseFloat(current.dispatchQty);
        //             const mergedAmount = calcAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc) });
        //             const mergedTaxAmount = calcTaxAmount({ dispatchQty: mergedDispatchQty, rate: parseFloat(current.rate), disc: parseFloat(current.disc), tax: parseFloat(current.tax) });

        //             return {
        //                 ...r,
        //                 UnitId: current.UnitId ?? r.UnitId,
        //                 unit: current.unit ?? r.unit,
        //                 qty: mergedQty,
        //                 dispatchQty: mergedDispatchQty,
        //                 rate: safeRate,
        //                 disc: Number(current.disc) || 0,
        //                 tax: parseFloat(current.tax) || r.tax,
        //                 GST: `${current.tax}%`,
        //                 CGST: isSameState ? (current.tax / 2).toString() : '0',
        //                 SGST: isSameState ? (current.tax / 2).toString() : '0',
        //                 IGST: isSameState ? '0' : current.tax.toString(),
        //                 amount: mergedAmount,
        //                 taxAmount: mergedTaxAmount,
        //                 taxableAmount: mergedAmount,
        //                 size: current.size || r.size || '',
        //                 color: current.color || r.color || '',
        //                 batchNo: current.batchNo || r.batchNo || '',
        //                 expDate: current.expDate || r.expDate || '',
        //                 serialNo: current.serialNo || r.serialNo || '',
        //                 remark: current.remark || r.remark || '',
        //                 minLevel: current.minLevel != null ? parseFloat(current.minLevel) : r.minLevel,
        //                 SOID: r.SOID || null,
        //                 SODtsID: r.SODtsID || null,
        //                 srNo: r.srNo,
        //                 id: r.srNo,
        //                 POID: r.POID ?? current.POID ?? null,
        //                 PODtsID: r.PODtsID ?? current.PODtsID ?? null,
        //             };
        //         }
        //         return r;
        //     }));
        // } else {
        //     row.srNo = editIndex != null ? rows[editIndex].srNo : nextSrNo;
        //     row.id = editIndex != null ? rows[editIndex].srNo : nextSrNo;
        //     if (editIndex != null) {
        //         setRows(prev => prev.map((r, i) => (i === editIndex ? { ...row } : r)));
        //     } else {
        //         setRows((prev) => [row, ...prev]);
        //         setNextSrNo(prev => prev + 1);
        //     }
        //     setIsEditingMode(false);
        // }

        if (editIndex != null) {
            setRows(prev => prev.map((r, i) => i === editIndex ? { ...row, srNo: rows[editIndex].srNo } : r));
        } else {
            row.srNo = nextSrNo;
            setRows(prev => [row, ...prev]);
            setNextSrNo(prev => prev + 1);
        }

        setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: '', dispatchQty: '', rate: 0, disc: 0, tax: 0, size: '', color: '', batchNo: '', expDate: '', serialNo: '', amount: '', remark: '', minLevel: null, TransType: 100, refNo: '', refDate: '', refQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth1Amt: '', oth2: '', oth2Amt: '', oth3: '', oth3Amt: '', UTGST: '0.00', GSTCess: '0.00', GSTOth: '0.00', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth4Amt: '', oth5: '', oth5Amt: '', oth6: '', oth6Amt: '', oth7: '', oth7Amt: '' });
        setErrors({});
        setEditIndex(null);
        setOriginalEditQty(null);
        setIsEditingMode(false);

        // Focus on Product Code field after adding product (not after updating)
        if (editIndex == null) {
            setTimeout(() => {
                productCodeRef.current?.focus?.();
            }, 0);
        }
    };

    // const editRow = idx => {
    //     const row = rows[idx];
    //     setCurrent({
    //         ...row,
    //         dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || 1,
    //         minLevel: row.minLevel,
    //         UnitId: row.UnitId || null,
    //         POID: row.POID ?? row.POId ?? null,
    //         PODtsID: row.PODtsID ?? row.PODtsId ?? null,
    //     });
    //     setEditIndex(idx);
    // };

    const editRow = idx => {
        const row = rows[idx];

        // This row's Qty/Rate/Pkg/Disc are about to be loaded into `current` from
        // the DB values — skip the next live-calculation pass so it doesn't
        // immediately overwrite the stored amount before the user edits anything.
        skipNextCalcRef.current = true;

        setCurrent({
            ...row,
            Id: row.productId || row.Id || '',
            isPOEditRestricted: isPOEditRestricted(row),
            rate: Number(row.rate) === 0 ? '' : row.rate,
            disc: Number(row.disc) === 0 ? '' : row.disc,
            dispatchQty: parseFloat(row.dispQty || row.dispatchQty) || '',
            minLevel: row.minLevel,
            UnitId: row.UnitId || null,
            POID: row.POID ?? row.POId ?? null,
            PODtsID: row.PODtsID ?? row.PODtsId ?? null,
            TaxId: row.TaxId || null,
        });
        setEditIndex(idx);
        setOriginalEditQty(parseFloat(row.qty) || 0);  // â† ADD THIS
        setIsEditingMode(true);                         // â† ADD THIS
    };

    // const deleteRow = idx => {
    //     setRows(prev => prev.filter((_, i) => i !== idx));
    //     if (idx === editIndex) {
    //         setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: 1, dispatchQty: 1, rate: 0, disc: 0, tax: 0, minLevel: null });
    //         setEditIndex(null);
    //         setErrors({});
    //     }
    // };

    const deleteRow = idx => {
        setRows(prev => prev.filter((_, i) => i !== idx));
        if (idx === editIndex) {
            setCurrent({ Id: '', productCode: '', description: '', unit: '', UnitId: null, qty: null, dispatchQty: null, rate: 0, disc: 0, tax: 0, minLevel: null, TransType: 100, refNo: '', refDate: '', refQty: '', type: '', pkg: '', freeQty: '', per: '', oth1: '', oth1Amt: null, oth2: '', oth2Amt: null, oth3: '', oth3Amt: null, UTGST: '0.00', GSTCess: '0.00', GSTOth: '0.00', poQty: '', ex4: '', ex5: '', exQty6: '', serialNo: '', oth4: '', oth4Amt: null, oth5: '', oth5Amt: null, oth6: '', oth6Amt: null, oth7: '', oth7Amt: null });
            setEditIndex(null);
            setErrors({});
            setOriginalEditQty(null);  // â† ADD THIS
        }
    };

    const handleNext = () => {
        if (rows.length === 0) {
            setErrors({ global: 'Add at least one product' });
            return;
        }

        if (hasInvalidDispatchQty()) {
            setErrors({ global: 'Correct invalid dispatch quantities before proceeding' });
            return;
        }

        const isSameState = state?.toLowerCase() === compState?.toLowerCase();

        const payloadRows = rows.map(r => {
            const qty = Number(r.qty) || 0;
            const dispatchQty = Number(r.dispatchQty) || 0;
            const rate = parseFloat(r.rate) || 0;
            const disc = parseFloat(r.disc) || 0;
            const pkg = Number(r.pkg ?? 1) || 1;
            const gross = getAmountCalcSafe(dispatchQty, rate, pkg, 0, isApplyPkgInAmtEnabled, calculateAmount).gross;
            const discAmt = Number((gross * (disc / 100)).toFixed(2));
            // Oth1→Oth7 are re-applied on top of the base taxable amount here too,
            // so the final submit payload always carries the Oth-adjusted amount
            // (matches what Add/Update Product already computed) instead of silently
            // reverting to the raw base.
            const { taxableAmt: taxableAmount, amounts: othAmountsFinal } = applyOthCharges(calcAmount(r), r);
            const taxAmount = parseFloat((taxableAmount * (parseFloat(r.tax || 0) / 100)).toFixed(2));
            const cgstRate = parseFloat(r.CGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
            const sgstRate = parseFloat(r.SGST) || (isSameState ? parseFloat(r.tax) / 2 : 0);
            const igstRate = parseFloat(r.IGST) || (isSameState ? 0 : parseFloat(r.tax));
            const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
            const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
            const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

            return {
                // âœ… FIX 1: Always carry ChallanDtsID forward so the backend can
                // do a true upsert (ON DUPLICATE KEY UPDATE) instead of blindly
                // deleting every row then inserting fresh ones.
                ChallanDtsID: r.ChallanDtsID ?? r.ChallanDtsId ?? r.challanDtsID ?? r.challanDtsId ?? null,

                // âœ… Carry PartyID so the backend can save it correctly
                PartyID: r.PartyID ?? r.partyID ?? null,

                productId: r.productId,
                productCode: r.productCode,
                description: r.description,
                UnitId: r.UnitId,
                unit: r.unit,
                origQty: qty,
                origDispatchQty: dispatchQty,

                qty: qty.toString(),
                dispatchQty: dispatchQty.toString(),
                // "Enable Convesrion effect in Transaction?" — ConversionQty/ConversionRate mirror
                // purcchallandetails' columns 1:1 (null on a normal, non-converted
                // row). stockQty is the base-unit-equivalent quantity to post to
                // stockinout's StockInQty; it equals dispatchQty/ConversionQty when
                // a conversion is active on this row, otherwise the plain dispatchQty.
                ConversionQty: r.ConversionQty != null ? Number(r.ConversionQty) : null,
                ConversionRate: r.ConversionRate != null ? Number(r.ConversionRate) : null,
                stockQty: r.ConversionQty
                    ? Number((dispatchQty / Number(r.ConversionQty)).toFixed(2))
                    : dispatchQty,
                rate: r.rate.toFixed(2),
                MRP: Number(r.MRP) || 0,
                disc: r.disc.toFixed(2),
                DiscAmt: discAmt,
                CGST: cgstRate.toFixed(2),
                CGSTAmt: cgstAmt,
                SGST: sgstRate.toFixed(2),
                SGSTAmt: sgstAmt,
                IGST: igstRate.toFixed(2),
                IGSTAmt: igstAmt,
                TaxId: r.TaxId ?? null,
                tax: parseFloat(r.tax),
                remark: r.remark || '',
                amount: taxableAmount.toFixed(2),
                taxAmount: taxAmount.toFixed(2),
                POID: r.POID ?? null,
                PODtsID: r.PODtsID ?? null,
                challanDtsID: r.challanDtsID || null,
                challanID: r.challanID || null,
                refNo: r.refNo || null,
                refDate: r.refDate || null,
                refQty: r.refQty || null,
                type: r.type || null,
                size: r.size || null,
                color: r.color || null,
                freeQty: r.freeQty || null,
                per: r.per || null,
                pkg: r.pkg || null,
                oth1: r.oth1 || null,
                oth1Amt: othAmountsFinal.oth1Amt,
                oth2: r.oth2 || null,
                oth2Amt: othAmountsFinal.oth2Amt,
                oth3: r.oth3 || null,
                oth3Amt: othAmountsFinal.oth3Amt,
                GSTOth: r.GSTOth || null,
                PONo: r.PONo || null,
                ProdPODate: r.ProdPODate || null,
                batchNo: r.batchNo || '',
                expDate: r.expDate || null,
                UTGST: r.UTGST || '0.00',
                GSTCess: r.GSTCess || '0.00',
                ProdPOQty: r.poQty || null,
                ex4: r.ex4 || null,
                ex5: r.ex5 || null,
                exQty6: r.exQty6 || null,
                serialNo: r.serialNo || null,
                oth4: r.oth4 || null,
                oth4Amt: othAmountsFinal.oth4Amt,
                oth5: r.oth5 || null,
                oth5Amt: othAmountsFinal.oth5Amt,
                oth6: r.oth6 || null,
                oth6Amt: othAmountsFinal.oth6Amt,
                oth7: r.oth7 || null,
                oth7Amt: othAmountsFinal.oth7Amt,
                SrNo: r.srNo || r.SrNo || null,
                TransType: r.TransType || 100,
            };
        });

        const summarySection = {
            totalProducts: rows.length,
            totalDispatchQty: rows.reduce((sum, r) => sum + parseFloat(r.dispatchQty), 0),
            products: rows.map(r => ({
                productCode: r.productCode,
                description: r.description,
                dispatchQty: r.dispatchQty.toString(),
                amount: calcAmount(r).toFixed(2),
                taxAmount: calcTaxAmount(r).toFixed(2),
            })),
        };

        // Additional Charges: charges saved in UserDefineColumns with ColToBeAsk=1
        // (i.e. present in `additionalCharges`, sourced from UserDefineContext) are
        // folded into the challan payload — Adc{SrNo}Amt/Adc{SrNo}TaxId in summary
        // for all 5 fixed slots, plus one pseudo item row per SELECTED charge
        // (TransType 200-204, SrNo 20000-20004) appended to tableData.
        // When a charge's Tax is disabled, its TaxId is resolved to the taxmaster
        // row where GST = 0 (found via gsts, whose `value` doubles as the % — same
        // pattern already used elsewhere in this file, e.g. parseFloat(opt.value)).
        const zeroTaxId = gsts.find(g => parseFloat(g.value) === 0)?.Id ?? null;

        const additionalChargeSummary = {};
        const additionalChargeItems = [];
        for (let slot = 1; slot <= 5; slot++) {
            const charge = additionalCharges.find(c => Number(c.SrNo) === slot);
            if (!charge) {
                additionalChargeSummary[`Adc${slot}Amt`] = 0;
                additionalChargeSummary[`Adc${slot}TaxId`] = null;
                continue;
            }
            const key = charge.TransType;
            const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
            const { taxPercent, taxAmount, finalAmount } = getChargeFinalAmounts(charge, input);
            const amount = Number(input.amount) || 0;
            const taxId = charge.TaxEnabled ? (input.taxId ?? null) : zeroTaxId;

            additionalChargeSummary[`Adc${slot}Amt`] = amount;
            additionalChargeSummary[`Adc${slot}TaxId`] = taxId;

            additionalChargeItems.push({
                Id: getChargeItemId('PCHAL', slot),
                productId: getChargeItemId('PCHAL', slot),
                productCode: charge.ChargeName || '',
                description: charge.ChargeName || '',
                // Additional Charge rows have no PartyID of their own — use the
                // dispatch's client so purcchallandetails.PartyID isn't left NULL
                // (same value the regular product rows carry via r.PartyID).
                PartyID: clientData?.clientId ?? null,
                UnitId: null,
                unit: '',

                origQty: '0',
                origDispatchQty: '0',

                // Additional Charge rows have no real PO/order qty, but the
                // backend's dispatch-quantity validation requires a valid number
                // (NaN/negative is rejected) and purcinvoicedetails.Qty stores
                // it as-is — qty/dispatchQty: '1' satisfies both, same string
                // shape as payloadRows above.
                qty: '1',
                dispatchQty: '1',

                rate: amount.toFixed(2),
                disc: (0).toFixed(2),
                CGST: (isSameState ? taxPercent / 2 : 0).toFixed(2),
                CGSTAmt: (isSameState ? taxAmount / 2 : 0).toFixed(2),
                SGST: (isSameState ? taxPercent / 2 : 0).toFixed(2),
                SGSTAmt: (isSameState ? taxAmount / 2 : 0).toFixed(2),
                IGST: (isSameState ? 0 : taxPercent).toFixed(2),
                IGSTAmt: (isSameState ? 0 : taxAmount).toFixed(2),
                TaxId: taxId,
                tax: Number(taxPercent.toFixed(2)),
                remark: '',
                amount: amount.toFixed(2),
                taxAmount: taxAmount.toFixed(2),
                POID: null,
                PODtsID: null,
                challanDtsID: null,
                challanID: null,
                soId: null,
                soDtsID: null,
                PONo: null,
                ProdPODate: null,
                POQty: null,
                type: null,
                size: null,
                color: null,
                freeQty: null,
                per: null,
                pkg: null,
                oth1: null,
                oth1Amt: null,
                oth2: null,
                oth2Amt: null,
                oth3: null,
                oth3Amt: null,
                oth4: null,
                oth4Amt: null,
                oth5: null,
                oth5Amt: null,
                oth6: null,
                oth6Amt: null,
                oth7: null,
                oth7Amt: null,
                Pf: null,
                PfAmt: null,
                Insu: null,
                InsuAmt: null,
                Freight: null,
                FreightAmt: null,
                DiscAmt: null,
                SOQty: null,
                GSTCEssAmt: '0.00',
                GSTCess: '0.00',
                GSTOth: '0.00',
                UTGSTAmt: '0.00',
                GSTEduCess: '0.00',
                GSTEducessAmt: '0.00',
                TCS: null,
                TCSAmt: null,
                TDS: null,
                TDSAmt: null,
                ex4: null,
                ex5: null,
                exQty6: null,
                serialNo: '',

                TaxableAmt: Number(finalAmount.toFixed(2)),
                batchNo: '',
                expDate: null,
                serialNo: '',
                configData: [],
                _isNew: true,
                configType: null,
                applyBatchNo: 0,
                applySerialNo: 0,
                warrantyMonths: null,
                expiryDays: null,
                srNo: 19999 + slot,
                dispQty: 1,
                gross: amount,
                refNo: null,
                refDate: null,
                refQty: null,

                // Fixed identifiers driving the backend's TransType-aware SrNo
                // override (see purchaseDispatchController.js).
                SrNo: 19999 + slot,
                TransType: 199 + slot,
            });
        }

        onNext({
            tableData: [...payloadRows, ...additionalChargeItems],
            summary: {
                ...totals,
                cgst: Number(totals.cgst) + Number(chargesSummary.cgst || 0),
                sgst: Number(totals.sgst) + Number(chargesSummary.sgst || 0),
                igst: Number(totals.igst) + Number(chargesSummary.igst || 0),
                total: Number(totals.total),
                ...additionalChargeSummary
            },
            summarySection,
            chargeInputs: chargeInputs
        });

        console.log('Payload sent:', { tableData: payloadRows, summary: totals, summarySection });
    };

    const formatINR = val => parseFloat(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const columns = [
        { field: 'srNo', headerName: '#', width: 40, align: 'center', headerAlign: 'center' },
        {
            field: 'product', headerName: 'Product', flex: 1, sortable: true, filterable: true,
            renderCell: params => {
                const { productCode, description, unit, tax, CGST, SGST, IGST, size, color, batchNo, expDate, serialNo, remark, PONumber, PODate } = params.row;
                const isSameState = state?.toLowerCase() === compState?.toLowerCase();
                const taxableAmount = calcAmount(params.row);
                const cgstRate = parseFloat(CGST) || (isSameState ? parseFloat(tax) / 2 : 0);
                const sgstRate = parseFloat(SGST) || (isSameState ? parseFloat(tax) / 2 : 0);
                const igstRate = parseFloat(IGST) || (isSameState ? 0 : parseFloat(tax));
                const cgstAmt = (taxableAmount * cgstRate / 100).toFixed(2);
                const sgstAmt = (taxableAmount * sgstRate / 100).toFixed(2);
                const igstAmt = (taxableAmount * igstRate / 100).toFixed(2);

                const hasPORef = rowHasPOReference(params.row);

                const isLocked =
                    (mode === 'edit' && hasPORef)

                const matchedGST = gsts.find(g => String(g.Id) === String(params.row.TaxId));
                const displayTax = matchedGST
                    ? (matchedGST.value?.toLowerCase().includes('tax free') ? '0%' : matchedGST.value)
                    : (!params.row.tax || Number(params.row.tax) === 0
                        ? '0%'
                        : `${params.row.tax}%`);

                return (
                    <Box sx={{ py: 0.5, display: 'flex', flexDirection: 'column' }}>
                        <Box>
                            {/* <Typography variant="body2" fontWeight="bold" component="div" sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }}
                                onClick={e => {
                                    e.stopPropagation();
                                    editRow(params.row.index);
                                }}
                            >
                                {productCode}
                            </Typography> */}
                            <Tooltip
                                title={
                                    mode === 'edit' && hasPORef
                                        ? 'This Challan is created by reference.'
                                        : mode === 'ref'
                                            ? 'Cannot edit in reference mode.'
                                            : ''
                                }
                                arrow
                                disableHoverListener={!isLocked}
                            >
                                <span>
                                    <Typography
                                        variant="body2"
                                        fontWeight="bold"
                                        component="div"
                                        sx={{
                                            color: '#1877F2',
                                            textDecoration: isLocked ? 'none' : 'underline',
                                            fontSize: '0.85rem'
                                        }}
                                        onClick={e => {
                                            e.stopPropagation();

                                            // âœ… ALLOWED
                                            editRow(params.row.index);
                                        }}
                                    >
                                        {productCode}
                                    </Typography>
                                </span>
                            </Tooltip>
                            <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                {description}
                            </Typography>
                        </Box>
                        {(isColVisible('Unit') || isColVisible('Taxcode')) && (
                            <Typography variant="caption" display="block">
                                {isColVisible('Unit') && `Unit: ${unit}`}
                                {isColVisible('Unit') && isColVisible('Taxcode') && ' | '}
                                {isColVisible('Taxcode') && `GST: ${displayTax}`}
                            </Typography>
                        )}
                        {(isSameState ? (isColVisible('CGST Rs.') || isColVisible('SGST Rs.')) : isColVisible('IGST Rs.')) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {isSameState
                                    ? [
                                        isColVisible('CGST Rs.') && `CGST: ₹${formatINR(cgstAmt)}`,
                                        isColVisible('SGST Rs.') && `SGST: ₹${formatINR(sgstAmt)}`,
                                    ].filter(Boolean).join(' + ')
                                    : `IGST: ₹${formatINR(igstAmt)}`}
                            </Typography>
                        )}
                        {((size && isColVisible('Size')) || (color && isColVisible('Color'))) && (
                            <Typography variant="caption" display="block">
                                {size && isColVisible('Size') && `Size: ${size}`} {color && isColVisible('Color') && `| Color: ${color}`}
                            </Typography>
                        )}
                        {((batchNo && isColVisible('Batch No')) || (expDate && isColVisible('Exp. Date'))) && (
                            <Typography variant="caption" display="block">
                                {batchNo && isColVisible('Batch No') && `Batch: ${batchNo}`}
                                {expDate && isColVisible('Exp. Date') && ` | Exp: ${expDate}`}
                            </Typography>
                        )}
                        {remark && isColVisible('Remark') && (<Typography variant="caption" display="block" color="text.secondary"> Remark: {remark} </Typography>)}
                        {OTH_FIELDS.some(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)]) && (
                            <Typography variant="caption" display="block" color="text.secondary">
                                {OTH_FIELDS
                                    .filter(({ field, col }) => isColVisible(col) && params.row[othDisplayField(field, col)])
                                    .map(({ field, col }) => {
                                        const rupees = isOthRupeesMode(col);
                                        const displayVal = params.row[othDisplayField(field, col)];
                                        const amt = params.row[`${field}Amt`];
                                        // Display-only: prefix with "-" when this Oth is configured as
                                        // subtract (AddLess=1) in UserDefineColumns — never "+", purely
                                        // cosmetic, doesn't touch stored values or calculations.
                                        const sign = Boolean(getColRow(col)?.AddLess) ? '-' : '';
                                        return rupees
                                            ? `${getColLabel(col, field)}: ${sign}₹${formatINR(displayVal)}`
                                            : `${getColLabel(col, field)}: ${displayVal}%${amt ? ` (${sign}₹${formatINR(amt)})` : ''}`;
                                    })
                                    .join(' | ')}
                            </Typography>
                        )}
                        {(PONumber || PODate) && (
                            <Typography variant="caption" display="block" color='blue'>
                                {PONumber && `PONo: ${PONumber}`}
                                {PODate && ` | Date: ${PODate}`}
                            </Typography>
                        )}
                    </Box>
                );
            },
        },
        { field: 'qty', headerName: 'PO Qty', width: 60, align: 'center', headerAlign: 'center', renderCell: params => params.row.qty },
        {
            field: 'dispatchQty',
            headerName: 'Qty',
            width: 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: params => {
                const product = productMap.get(params.row.productId);
                const minLevel = params.row.minLevel === null ? Infinity : parseFloat(params.row.minLevel) || parseFloat(product?.minLevel) || Infinity;
                const hasPORef = !!(params.row.POID || params.row.PODtsID);
                const { isValid, correctedValue } = validateDispatchQty(params.row.dispatchQty, params.row.qty, minLevel, product?.minLevel, hasPORef);

                // ============ ADD THIS LINE ============
                const isRowLocked = mode === 'edit' && rowHasPOReference(params.row);
                // ========================================

                return (
                    <TextField
                        type="number"
                        size="small"
                        value={params.row.dispatchQty}
                        disabled={isRowLocked}  // â† ADD THIS
                        inputProps={{ min: 0, max: Math.min(params.row.qty, minLevel), step: 'any' }}
                        sx={{
                            width: 80,
                            '& .MuiOutlinedInput-root': { height: 32 },
                            '& .MuiOutlinedInput-notchedOutline': { borderColor: isValid ? undefined : 'red' },
                        }}
                        onChange={e => {
                            if (isRowLocked) return;  // â† ADD THIS GUARD

                            const raw = e.target.value;
                            const v = parseFloat(raw);
                            const updatedAmount = calcAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc
                            });
                            const updatedTaxAmount = calcTaxAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc,
                                tax: params.row.tax
                            });
                            setRows(prev => prev.map((r, i) => (i === params.row.index ? {
                                ...r,
                                dispatchQty: v,
                                amount: updatedAmount,
                                taxAmount: updatedTaxAmount,
                                taxableAmount: updatedAmount
                            } : r)));
                        }}
                        onBlur={() => {
                            if (isRowLocked) return;

                            // âœ… Use hasPORef-aware limit â€” free rows are not capped by qty
                            const limit = hasPORef
                                ? Math.min(params.row.qty, minLevel)
                                : (isFinite(minLevel) ? minLevel : params.row.dispatchQty);
                            let v = parseFloat(params.row.dispatchQty);
                            if (!Number.isFinite(v) || v <= 0 || v > limit) {
                                v = correctedValue;
                            }
                            const updatedAmount = calcAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc
                            });
                            const updatedTaxAmount = calcTaxAmount({
                                dispatchQty: v,
                                rate: params.row.rate,
                                disc: params.row.disc,
                                tax: params.row.tax
                            });
                            setRows(prev => prev.map((r, i) => (i === params.row.index ? {
                                ...r,
                                dispatchQty: v,
                                amount: updatedAmount,
                                taxAmount: updatedTaxAmount,
                                taxableAmount: updatedAmount
                            } : r)));
                        }}
                    />
                );
            },
        },
        { field: 'rate', headerName: 'Rate', width: 90, align: 'right', headerAlign: 'center', renderCell: params => `₹${formatINR(params.row.rate)}` },
        {
            field: 'disc', headerName: 'Disc', width: 50, align: 'center', headerAlign: 'center',
            renderHeader: () => (
                <Box sx={{ textAlign: 'center', lineHeight: 1.2 }}>
                    <Typography variant="body2">Disc</Typography>
                    <Typography variant="caption" color="text.secondary">(%)</Typography>
                </Box>
            ),
        },
        { field: 'amount', headerName: 'Amount (₹)', width: 90, align: 'right', headerAlign: 'right', renderCell: params => `₹${formatINR(parseFloat(params.row.amount || 0))}` },
        {
            width: 30, sortable: false, filterable: false, align: 'center', headerAlign: 'center',
            renderCell: params => (
                // <IconButton size="small" onClick={() => deleteRow(params.row.index)} color="error">
                //     <DeleteIcon fontSize="small" />
                // </IconButton>

                <IconButton
                    size="small"
                    onClick={() => deleteRow(params.row.index)}
                    color="error"
                    disabled={mode === 'edit' && rowHasPOReference(params.row)}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>

            ),
        },
    ];

    const rowHasPOReference = (row) => {
        // console.log(row.PODtsId || row.PODtsID)
        return (row.POId || row.POID) || (row.PODtsId || row.PODtsID);
    };

    // Check if ANY row has SO reference (for disabling add product button)
    const hasAnyPOReference = () => {
        return rows.some(r => rowHasPOReference(r));
    };

    const isPOEditRestricted = (row) => {
        return mode === 'edit' && rowHasPOReference(row);
    };

    const isAddProductDisabled = () => {
        if (hasInvalidDispatchQty()) return true;

        // ðŸ”¥ Disable only when adding new in ref mode
        if (mode === 'ref' && editIndex == null) return true;

        if (isEditingMode && editIndex == null) return true;

        if (mode === 'edit' && isFinalLocked) return true;

        return false;
    };

    return (
        <Paper sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" flexDirection={isSmall ? 'column' : 'row'} gap={2} sx={{ width: '100%', boxSizing: 'border-box', flexWrap: isSmall ? 'wrap' : 'nowrap', overflow: 'hidden' }} >
                <Box display="flex" flexDirection="column" gap={1.5} sx={{ width: '100%', maxWidth: isSmall ? '100%' : 420, boxSizing: 'border-box', p: 1, borderRight: isSmall ? 'none' : '1px solid #e0e0e0', flex: { lg: '1 1 100%' }, }} >
                    <Box>
                        <DropdownProductCode ref={productCodeRef} id="productCode" options={allProducts} value={current.productCode} onSelect={handleSelect} onNewProductAdded={loadAllProducts} connectionString={connectionString} disabled={mode === "ref" || current.isPOEditRestricted} onProductMasterClose={handleProductAdded} autoFocus={!initialData?.tableData?.length} />
                        {!!errors.productCode && <Typography color="error" variant="caption">{errors.productCode}</Typography>}
                    </Box>
                    <Typography variant="caption" color="text.secondary" sx={{ my: -1.3 }}>
                        Available Dispatch Qty: {current.minLevel === null ? 'N/A' : parseFloat(current.minLevel) || 'N/A'}
                    </Typography>
                    {/* <TextField label="Description" required disabled={current.isPOEditRestricted} fullWidth multiline minRows={1} size="small" placeholder="Enter product description" value={current.description} onChange={handleChange('description')} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiInputBase-root:not(.MuiInputBase-multiline)': { height: 38 }, '& .MuiOutlinedInput-inputMultiline': { padding: '0px 12px', minHeight: '80px' } }} /> */}
                    {isColVisible('Description') && (
                        <Box>
                            <DropdownProductCode
                                id="description"
                                label="Description"
                                options={allProducts}
                                value={current.description}
                                onSelect={handleSelect}
                                onNewProductAdded={loadAllProducts}
                                connectionString={connectionString}
                                searchBy="description"   // ðŸ”¥ key
                                disabled={current.isPOEditRestricted}
                                onProductMasterClose={handleProductAdded}
                            />
                        </Box>
                    )}
                    {/* {(isColVisible('Ref.No') || isColVisible('Ref. Date') || isColVisible('Ref. Qty')) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible('Ref.No') && (
                                <TextField label="Ref. No" size="small" fullWidth value={current.refNo} onChange={handleChange('refNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Date') && (
                                <TextField label="Ref. Date" type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.refDate} onChange={handleChange('refDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible('Ref. Qty') && (
                                <TextField label="Ref. Qty" type="number" size="small" fullWidth value={current.refQty} onChange={handleChange('refQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )} */}
                    {(isColVisible(COL.PO_NO) || isColVisible(COL.PO_DATE) || isColVisible(COL.PO_QTY)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PO_NO) && (
                                <TextField label={getColLabel(COL.PO_NO, 'PO No')} size="small" fullWidth value={current.PONo} onChange={handleChange('PONo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_DATE) && (
                                <TextField label={getColLabel(COL.PO_DATE, 'PO Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.ProdPODate} onChange={handleChange('ProdPODate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PO_QTY) && (
                                <TextField label={getColLabel(COL.PO_QTY, 'PO Qty')} type="number" size="small" fullWidth value={current.poQty} onChange={handleChange('poQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.TYPE) || isColVisible(COL.SIZE) || isColVisible(COL.COLOR)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.TYPE) && (
                                <TextField label={getColLabel(COL.TYPE, 'Type')} size="small" fullWidth value={current.type} onChange={handleChange('type')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.SIZE) && (
                                <TextField label={getColLabel(COL.SIZE, 'Size')} size="small" fullWidth value={current.size} onChange={handleChange('size')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.COLOR) && (
                                <TextField label={getColLabel(COL.COLOR, 'Color')} size="small" fullWidth value={current.color} onChange={handleChange('color')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box display="flex" flexDirection="row" gap={1.5}>
                        {isColVisible(COL.UNIT) && (
                            <TextField label={getColLabel(COL.UNIT, 'Unit')} select required fullWidth size="small" disabled={current.isPOEditRestricted} value={current.unit} onChange={handleChange('unit')} SelectProps={{ native: true }} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} error={!!errors.unit} helperText={errors.unit} >
                                <option value=""></option>
                                {unitOptions.map(u => (
                                    <option key={u} value={u}>
                                        {u}
                                    </option>
                                ))}
                            </TextField>
                        )}
                        {/* <TextField label="Tax(%)" fullWidth type="number" disabled value={current.tax} onChange={handleChange('tax')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} /> */}
                        {isColVisible(COL.TAX_CODE) && (
                            <Dropdown
                                id="gst"
                                label="GST"
                                valueKey="Id"
                                labelKey="value"
                                value={current.TaxId ? String(current.TaxId) : ""}
                                options={gsts}
                                required
                                onChange={(opt) => {
                                    if (!opt) {
                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: 0,
                                            TaxId: null
                                        }));
                                    } else {
                                        const gstValue = parseFloat(opt.value) || 0;

                                        // "Apply MRP in Purchase?" — if MRP is already set on
                                        // this row, re-derive Rate from it using the newly-picked
                                        // GST rate, keeping Rate/MRP consistent.
                                        if (isApplyMRPInPurchaseEnabled && current.MRP && Number(current.MRP) > 0) {
                                            const newRate = calculatePurchaseRateFromMRP(Number(current.MRP), gstValue);
                                            setCurrent(prev => ({
                                                ...prev,
                                                tax: gstValue,
                                                TaxId: opt.Id,
                                                rate: newRate,
                                            }));
                                            return;
                                        }

                                        setCurrent(prev => ({
                                            ...prev,
                                            tax: gstValue,   // % value used in calculation
                                            TaxId: opt.Id    // backend id
                                        }));
                                    }
                                }}
                                error={!!errors.TaxId}
                            />
                        )}
                        <TextField label="PO Qty" size='small' disabled fullWidth type="number" value={current.qty} onChange={handleChange('qty')} error={!!errors.qty} helperText={errors.qty} InputLabelProps={{ sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    </Box>
                    {(isColVisible(COL.BATCH_NO) || isColVisible(COL.EXP_DATE)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.BATCH_NO) && (
                                <TextField label={getColLabel(COL.BATCH_NO, 'Batch No')} size="small" fullWidth value={current.batchNo} onChange={handleChange('batchNo')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.EXP_DATE) && (
                                <TextField label={getColLabel(COL.EXP_DATE, 'Exp. Date')} type="date" size="small" fullWidth InputLabelProps={{ shrink: true }} value={current.expDate} onChange={handleChange('expDate')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>

                        {isColVisible(COL.QTY) && (
                        <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField
                            label={getColLabel(COL.QTY, 'Qty')}
                            type="number"
                            size="small"
                            fullWidth
                            required
                            value={current.dispatchQty}
                            disabled={current.isPOEditRestricted}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: errors.dispatchQty ? 'red' : undefined }, }}
                            onChange={handleChange('dispatchQty')}
                            error={!!errors.dispatchQty}
                            helperText={errors.dispatchQty}
                            InputLabelProps={{ sx: requiredAsteriskStyle }}
                            inputProps={{
                                min: 0,
                                max: (() => {
                                    const product = productMap.get(current.Id);

                                    const minLevel =
                                        current.minLevel === null
                                            ? (parseFloat(product?.minLevel) || Infinity)
                                            : parseFloat(current.minLevel) || Infinity;

                                    const hasPORef = rowHasPOReference(current);

                                    if (mode === 'add') return minLevel;

                                    if (mode === 'edit' && hasPORef) {
                                        return Math.min(parseFloat(current.qty) || 1, minLevel);
                                    }

                                    if (mode === 'ref') {
                                        return Math.min(parseFloat(current.qty) || 1, minLevel);
                                    }

                                    return minLevel;
                                })(),
                                step: 'any'
                            }}

                            onBlur={() => {
                                const product = productMap.get(current.Id);
                                const hasPORef = !!(current.POID || current.PODtsID);
                                const minLevel = current.minLevel === null ? (parseFloat(product?.minLevel) || Infinity) : parseFloat(current.minLevel) || Infinity;

                                const limit = hasPORef ? Math.min(parseFloat(current.qty) || 1, minLevel) : minLevel;

                                const { isValid, correctedValue } = validateDispatchQty(current.dispatchQty, current.qty, current.minLevel, product?.minLevel, hasPORef);

                                if (!isValid) {
                                    setCurrent(prev => ({ ...prev, dispatchQty: correctedValue }));
                                    setErrors(prev => ({ ...prev, dispatchQty: `Dispatch Qty must be greater than 0 and up to ${limit}`, }));
                                } else {
                                    setErrors(prev => ({ ...prev, dispatchQty: undefined }));
                                }
                            }}
                        />
                        </Box>
                        )}
                        {isApplyMRPInPurchaseEnabled && (
                        <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField
                            label="MRP"
                            size="small"
                            fullWidth
                            type="number"
                            inputProps={{ min: 0 }}
                            value={current.MRP}
                            onChange={(e) => {
                                const val = e.target.value;
                                const mrpValue = Number(val) || 0;

                                setCurrent(prev => ({
                                    ...prev,
                                    MRP: val === '' ? '' : mrpValue
                                }));

                                if (mrpValue > 0 && current.tax > 0) {
                                    const newRate = calculatePurchaseRateFromMRP(mrpValue, current.tax);
                                    setCurrent(prev => ({
                                        ...prev,
                                        rate: newRate,
                                    }));
                                }
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }}
                        />
                        </Box>
                        )}
                        {isColVisible(COL.RATE) && (
                        <Box sx={{ flex: 1, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField label={getColLabel(COL.RATE, 'Rate')} size="small" fullWidth type="number" value={current.rate} onChange={handleChange('rate')} inputProps={{ min: 0 }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} disabled={isApplyMRPInPurchaseEnabled} />
                        </Box>
                        )}
                        {isColVisible(COL.DISC) && (
                        <Box sx={{ flex: 0.75, minWidth: 60, display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                        <TextField label={getColLabel(COL.DISC, 'Disc%')} size="small" fullWidth type="number" value={current.disc} onChange={handleBaseFieldChange('disc')} inputProps={{ min: 0, max: 100 }} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                        </Box>
                        )}
                    </Box>
                    {(isColVisible(COL.PKG) || isColVisible(COL.FREE_QTY) || isColVisible(COL.PER)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.PKG) && (
                                <TextField label={getColLabel(COL.PKG, 'Pkg')} size="small" fullWidth value={current.pkg || ''} onChange={handleChange('pkg')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.FREE_QTY) && (
                                <TextField label={getColLabel(COL.FREE_QTY, 'Free Qty')} type="number" size="small" fullWidth value={current.freeQty} onChange={handleChange('freeQty')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.PER) && (
                                <TextField label={getColLabel(COL.PER, 'Per')} size="small" fullWidth value={current.per} onChange={handleChange('per')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH1) || isColVisible(COL.OTH2) || isColVisible(COL.OTH3)) && (
                        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={1.5}>
                            {isColVisible(COL.OTH1) && (
                                <TextField label={getColLabel(COL.OTH1, 'Oth 1')} size="small" fullWidth type="number" value={current[othDisplayField('oth1', COL.OTH1)] || ''} onChange={handleOthChange('oth1', COL.OTH1)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH1) && !isOthRupeesMode(COL.OTH1) && (
                                <TextField label={`${getColLabel(COL.OTH1, 'Oth 1')} Amount`} size="small" fullWidth disabled value={current.oth1Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && (
                                <TextField label={getColLabel(COL.OTH2, 'Oth 2')} size="small" fullWidth type="number" value={current[othDisplayField('oth2', COL.OTH2)] || ''} onChange={handleOthChange('oth2', COL.OTH2)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH2) && !isOthRupeesMode(COL.OTH2) && (
                                <TextField label={`${getColLabel(COL.OTH2, 'Oth 2')} Amount`} size="small" fullWidth disabled value={current.oth2Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && (
                                <TextField label={getColLabel(COL.OTH3, 'Oth 3')} size="small" fullWidth type="number" value={current[othDisplayField('oth3', COL.OTH3)] || ''} onChange={handleOthChange('oth3', COL.OTH3)} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.OTH3) && !isOthRupeesMode(COL.OTH3) && (
                                <TextField label={`${getColLabel(COL.OTH3, 'Oth 3')} Amount`} size="small" fullWidth disabled value={current.oth3Amt || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {isColVisible(COL.SERIAL_NO) && <TextField size="small" label={getColLabel(COL.SERIAL_NO, 'Serial No')} value={current.serialNo || ''} onChange={(e) => setCurrent(p => ({ ...p, serialNo: e.target.value }))} fullWidth />}
                    {(isColVisible(COL.EX4) || isColVisible(COL.EX5) || isColVisible(COL.EX_QTY6)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mb: 2 }}>
                            {isColVisible(COL.EX4) && <TextField size="small" label={getColLabel(COL.EX4, 'EX4')} value={current.ex4 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex4: e.target.value }))} />}
                            {isColVisible(COL.EX5) && <TextField size="small" label={getColLabel(COL.EX5, 'EX5')} value={current.ex5 || ''} onChange={(e) => setCurrent(p => ({ ...p, ex5: e.target.value }))} />}
                            {isColVisible(COL.EX_QTY6) && <TextField size="small" label={getColLabel(COL.EX_QTY6, 'EXQty6')} type="number" value={current.exQty6 || ''} onChange={(e) => setCurrent(p => ({ ...p, exQty6: e.target.value }))} />}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH4) || isColVisible(COL.OTH5)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH4) && <TextField size="small" type="number" label={getColLabel(COL.OTH4, 'Oth 4')} value={current[othDisplayField('oth4', COL.OTH4)] || ''} onChange={handleOthChange('oth4', COL.OTH4)} />}
                            {isColVisible(COL.OTH4) && !isOthRupeesMode(COL.OTH4) && <TextField size="small" disabled label={`${getColLabel(COL.OTH4, 'Oth 4')} Amount`} value={current.oth4Amt || ''} />}
                            {isColVisible(COL.OTH5) && <TextField size="small" type="number" label={getColLabel(COL.OTH5, 'Oth 5')} value={current[othDisplayField('oth5', COL.OTH5)] || ''} onChange={handleOthChange('oth5', COL.OTH5)} />}
                            {isColVisible(COL.OTH5) && !isOthRupeesMode(COL.OTH5) && <TextField size="small" disabled label={`${getColLabel(COL.OTH5, 'Oth 5')} Amount`} value={current.oth5Amt || ''} />}
                        </Box>
                    )}
                    {(isColVisible(COL.OTH6) || isColVisible(COL.OTH7)) && (
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))', gap: 2, mb: 2 }}>
                            {isColVisible(COL.OTH6) && <TextField size="small" type="number" label={getColLabel(COL.OTH6, 'Oth 6')} value={current[othDisplayField('oth6', COL.OTH6)] || ''} onChange={handleOthChange('oth6', COL.OTH6)} />}
                            {isColVisible(COL.OTH6) && !isOthRupeesMode(COL.OTH6) && <TextField size="small" disabled label={`${getColLabel(COL.OTH6, 'Oth 6')} Amount`} value={current.oth6Amt || ''} />}
                            {isColVisible(COL.OTH7) && <TextField size="small" type="number" label={getColLabel(COL.OTH7, 'Oth 7')} value={current[othDisplayField('oth7', COL.OTH7)] || ''} onChange={handleOthChange('oth7', COL.OTH7)} />}
                            {isColVisible(COL.OTH7) && !isOthRupeesMode(COL.OTH7) && <TextField size="small" disabled label={`${getColLabel(COL.OTH7, 'Oth 7')} Amount`} value={current.oth7Amt || ''} />}
                        </Box>
                    )}
                    {(isColVisible(COL.UTGST) || isColVisible(COL.GST_CESS) || isColVisible(COL.GST_OTH)) && (
                        <Box display="flex" flexDirection="row" gap={1.5}>
                            {isColVisible(COL.UTGST) && (
                                <TextField label={getColLabel(COL.UTGST, 'UTGST')} size="small" fullWidth type="number" value={current.UTGST} onChange={handleChange('UTGST')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_CESS) && (
                                <TextField label={getColLabel(COL.GST_CESS, 'GST Cess')} size="small" fullWidth type="number" value={current.GSTCess} onChange={handleChange('GSTCess')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                            {isColVisible(COL.GST_OTH) && (
                                <TextField label={getColLabel(COL.GST_OTH, 'GST Oth')} size="small" fullWidth type="number" value={current.GSTOth} onChange={handleChange('GSTOth')} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                            )}
                        </Box>
                    )}
                    {isColVisible(COL.AMOUNT) && (
                        <TextField label={getColLabel(COL.AMOUNT, 'Amount')} fullWidth disabled type="number" size="small" value={current.amount} sx={{ '& .MuiOutlinedInput-root': { height: 38, alignItems: 'center' } }} />
                    )}
                    {isColVisible(COL.REMARK) && (
                        <TextField label={getColLabel(COL.REMARK, 'Remark')} fullWidth multiline minRows={1} maxRows={3} size="small" value={current.remark || ''} onChange={handleChange('remark')} inputProps={{ maxLength: 250 }} helperText={`${(current.remark || '').length}/250 characters`} />
                    )}
                    <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                        {isShowOnlineStockPurchaseEnabled && current.Id && (
                            <Box display="flex" gap={2} justifyContent="center">
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: '#666' }}>
                                        Closing Stock
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: onlineStockDetails.closingStock <= 0 ? '#d32f2f' : '#2e7d32',
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.closingStock !== null ? onlineStockDetails.closingStock.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: '#666' }}>
                                        Max Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.maxLevel !== null ? onlineStockDetails.maxLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="caption" sx={{ fontSize: '12px', fontWeight: 600, color: '#666' }}>
                                        Min Level
                                    </Typography>
                                    <Typography sx={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f57c00',
                                        mt: 0.3
                                    }}>
                                        {onlineStockDetails.minLevel !== null ? onlineStockDetails.minLevel.toFixed(2) : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                        {/* <Button variant="outlined" onClick={addProduct} sx={{ minWidth: 180 }} disabled={hasInvalidDispatchQty()}>
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button> */}
                        <Button
                            variant="outlined"
                            onClick={addProduct}
                            sx={{ minWidth: 180 }}
                        // disabled={isAddProductDisabled()}
                        >
                            {editIndex != null ? 'Update Product' : 'Add Product'}
                        </Button>

                    </Box>
                </Box>
                <Box sx={{ width: isSmall ? '100%' : 670, maxWidth: '100%', p: isSmall ? 0 : 0, pl: 2, marginTop: isMobile ? -1 : -4, flexShrink: 0 }}>
                    {isMobile ? (
                        <Box>
                            {rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((row, i) => (
                                <Box key={i} sx={{ border: "1px solid #cbd5e1", borderRadius: 2, p: 1.5, mb: 1.5, cursor: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref') ? 'not-allowed' : 'pointer', color: (mode === 'edit' && rowHasPOReference(row) || mode === 'ref') && "text.disabled", }} >
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {row.productCode} â€”{" "}
                                        <Box
                                            component="span"
                                            sx={{
                                                fontStyle: "italic",
                                                fontWeight: "normal",
                                                display: "inline",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal"
                                            }}
                                        >
                                            {row.description}
                                        </Box>
                                    </Typography>

                                    {(row.PONumber || row.PODate) && (
                                        <Typography variant="caption" display="block" color='blue'>
                                            {row.PONumber && `PONo: ${row.PONumber}`}
                                            {row.PODate && ` | Date: ${row.PODate}`}
                                        </Typography>
                                    )}

                                    <Grid container justifyContent="space-between">
                                        <Typography>Qty:</Typography>
                                        <Typography>{row.qty}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Rate:</Typography>
                                        <Typography>₹{row.rate}</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Disc:</Typography>
                                        <Typography>{row.disc}%</Typography>
                                    </Grid>

                                    <Grid container justifyContent="space-between">
                                        <Typography>Amount:</Typography>
                                        <Typography>₹{row.amount}</Typography>
                                    </Grid>

                                    {/* TAX INFO */}
                                    <Grid container justifyContent="space-between">
                                        <Typography>GST:</Typography>
                                        <Typography>{row.tax}%</Typography>
                                    </Grid>

                                    {state?.toLowerCase() === compState?.toLowerCase() ? (
                                        <>
                                            <Grid container justifyContent="space-between">
                                                <Typography>CGST:</Typography>
                                                <Typography>₹{formatINR(row.cgst)}</Typography>
                                            </Grid>
                                            <Grid container justifyContent="space-between">
                                                <Typography>SGST:</Typography>
                                                <Typography>₹{formatINR(row.sgst)}</Typography>
                                            </Grid>
                                        </>
                                    ) : (
                                        <Grid container justifyContent="space-between">
                                            <Typography>IGST:</Typography>
                                            <Typography>₹{formatINR(row.igst)}</Typography>
                                        </Grid>
                                    )}

                                    {/* Remark */}
                                    {row.remark && row.remark.trim() !== '' && (
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                mt: 1,
                                                display: 'block',
                                                wordBreak: 'break-word',
                                                overflowWrap: 'anywhere',
                                                whiteSpace: 'normal'
                                            }}
                                        >
                                            Remark: {row.remark}
                                        </Typography>
                                    )}

                                    {/* DELETE / EDIT BUTTONS IF NEEDED */}
                                    <Box display="flex" justifyContent="flex-end" mt={1} gap={0.5}>
                                        <IconButton size="small" onClick={() => editRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <IconButton size="small" color="error" onClick={() => deleteRow(i)} disabled={mode === 'edit' && rowHasPOReference(row) || mode === 'ref'}>
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    ) : (
                        <DataGrid rows={rows.filter(r => r.TransType !== 200 && r.TransType !== 201 && r.TransType !== 202 && r.TransType !== 203 && r.TransType !== 204 && r.TransType !== 300).map((r, i) => ({ ...r, id: i + 1, index: i }))} columns={columns} getRowHeight={() => 'auto'} autoHeight disableRowSelectionOnClick hideFooter
                            sx={{
                                mt: 5, border: '1px solid #cbd5e1', borderRadius: 1,
                                '& .MuiDataGrid-columnHeaders': { minHeight: 55, maxHeight: 55 },
                                '& .MuiDataGrid-columnHeader': { backgroundColor: '#f0f0f0', paddingTop: '4px', paddingBottom: '4px', height: 42, lineHeight: '1.2rem', fontSize: '13px' },
                                '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#edf2feff' },
                                '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#ffffff' }
                            }}
                        />
                    )}
                    <Box mt={3}>
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Basic Amount</Typography>
                            <Typography>₹{formatINR(totals.basic)}</Typography>
                        </Grid>
                        <Typography variant="caption" color="text.secondary" display="block" mb={1}>
                            Total Discounted Amount: ₹{formatINR(totals.discount)}
                        </Typography>

                        {additionalCharges.length > 0 && (
                            <Box mb={2}>
                                <Accordion
                                    expanded={chargesCollapsibleOpen !== false ? true : chargesCollapsibleOpen}
                                    onChange={() => setChargesCollapsibleOpen(!chargesCollapsibleOpen)}
                                    sx={{ width: '100%' }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ py: 0.75, minHeight: 'auto' }}>
                                        <Typography variant="subtitle2">Charges</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ py: 1, px: 1 }}>
                                        <Box sx={{ width: '100%', overflowX: 'auto' }}>
                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <colgroup>
                                                    <col style={{ width: '45%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '18%' }} />
                                                    <col style={{ width: '19%' }} />
                                                </colgroup>
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Charge Name</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Amount</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', borderRight: '1px solid #ddd', fontWeight: 600, fontSize: '12px' }}>Tax</th>
                                                        <th style={{ padding: '6px 8px', textAlign: 'left', fontWeight: 600, fontSize: '12px' }}>Final Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {additionalCharges.map(charge => {
                                                        const key = charge.TransType;
                                                        if (!chargeInputs[key]) {
                                                            updateChargeInput(key, { amount: '', taxId: charge.TaxId ?? null });
                                                        }
                                                        const input = chargeInputs[key] || { amount: '', taxId: charge.TaxId ?? null };
                                                        const { finalAmount } = getChargeFinalAmounts(charge, input);

                                                        return (
                                                            <tr key={key} style={{ borderBottom: '1px solid #ddd' }}>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    <Typography variant="caption" sx={{ fontSize: '12px' }}>{charge.ChargeName}</Typography>
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={input.amount}
                                                                        onChange={(e) => updateChargeInput(key, { amount: e.target.value })}
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px 8px', borderRight: '1px solid #ddd', verticalAlign: 'middle' }}>
                                                                    {charge.TaxEnabled ? (
                                                                        <Dropdown
                                                                            id={`charge-tax-${key}`}
                                                                            valueKey="Id"
                                                                            labelKey="value"
                                                                            value={input.taxId ? String(input.taxId) : ""}
                                                                            options={gsts}
                                                                            onChange={(opt) => updateChargeInput(key, { taxId: opt ? opt.Id : null })}
                                                                        />
                                                                    ) : (
                                                                        <Typography variant="caption" sx={{ color: '#999', fontSize: '12px' }}>N/A</Typography>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px 8px', verticalAlign: 'middle' }}>
                                                                    <TextField
                                                                        size="small"
                                                                        fullWidth
                                                                        type="number"
                                                                        value={finalAmount.toFixed(2)}
                                                                        disabled
                                                                        sx={{ '& .MuiOutlinedInput-root': { height: 30, backgroundColor: '#f5f5f5', fontSize: '12px' } }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        )}

                        {state?.toLowerCase() === compState?.toLowerCase() ? (
                            <>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>CGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.cgst) + chargesSummary.cgst)}</Typography>
                                </Grid>
                                <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                    <Typography>SGST</Typography>
                                    <Typography>₹{formatINR(Number(totals.sgst) + chargesSummary.sgst)}</Typography>
                                </Grid>
                            </>
                        ) : (
                            <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography>IGST</Typography>
                                <Typography>₹{formatINR(Number(totals.igst) + chargesSummary.igst)}</Typography>
                            </Grid>
                        )}
                        <Grid container justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography>Round Off ({Number(totals.roundOff) >= 0 ? '+' : '-'})</Typography>
                            <Typography>₹{formatINR(totals.roundOff)}</Typography>
                        </Grid>

                        <Divider sx={{ my: 1 }} />
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Typography fontWeight={600}>Total Amount</Typography>
                            <Typography fontWeight={600}>₹{formatINR(Number(totals.total))}</Typography>
                        </Grid>
                    </Box>
                </Box>
            </Box>
            {!!errors.global && <Typography color="error" sx={{ mt: 2 }}>{errors.global}</Typography>}
            <Box mt={1} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={isEditingMode}> Next </Button>
            </Box>


            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Dialog
                open={stockWarningOpen}
                onClose={() => {
                    setStockWarningOpen(false);
                    if (stockConfirmResolve) stockConfirmResolve(false);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ backgroundColor: '#d32f2f', color: 'white', fontWeight: 'bold' }}>
                    ⚠️ Stock Warning
                </DialogTitle>
                <DialogContent sx={{ mt: 2, mb: 1 }}>
                    <p style={{ color: '#d32f2f', fontWeight: 500 }}>
                        {stockWarningData?.message || 'Stock will exceed maximum level. Do you want to save?'}
                    </p>
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(false);
                        }}
                        sx={{ textTransform: 'none' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setStockWarningOpen(false);
                            if (stockConfirmResolve) stockConfirmResolve(true);
                        }}
                        sx={{ backgroundColor: '#d32f2f', textTransform: 'none', '&:hover': { backgroundColor: '#b71c1c' } }}
                    >
                        Yes, Save Anyway
                    </Button>
                </DialogActions>
            </Dialog>

            {/* "Enable Convesrion effect in Transaction?" — Conversion Qty popup, shown when Unit is
                changed away from the product's default Unit. */}
            <Dialog
                open={conversionQtyDialogOpen}
                onClose={handleCancelConversionQty}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                    Unit Conversion
                </DialogTitle>
                <DialogContent sx={{ py: 3 }}>
                    <Typography sx={{ fontSize: '14px', color: '#555', mb: 2 }}>
                        How many {pendingUnitChange?.unit || 'unit'} make 1 {current.defaultUnit || current.unit || 'base unit'}?
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Conversion Qty"
                        size="small"
                        type="text"
                        value={conversionQtyInput}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === '' || /^\d*\.?\d{0,4}$/.test(val)) setConversionQtyInput(val);
                        }}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        variant="outlined"
                        onClick={handleCancelConversionQty}
                        sx={{ color: '#666', borderColor: '#ddd' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmConversionQty}
                        sx={{ bgcolor: '#1877F2', '&:hover': { bgcolor: '#0d5dc7' } }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

        </Paper>
    );
};

export default ProductDetails;
